{
  "NLRTM": [
    {
      "descriptions": [
        "Zwijndrecht/Dordrecht tot Dordtse brug"
      ],
      "berths": [
        "O785",
        "O796",
        "O797",
        "O804",
        "O805",
        "O806",
        "O817",
        "O826",
        "O850",
        "O876",
        "O4239",
        "O4344",
        "O4353",
        "O4357",
        "O4358",
        "O4885",
        "O4972",
        "O4981",
        "O4983",
        "O4991",
        "O4998",
        "O5017",
        "O6773",
        "O6775",
        "O6776",
        "O6778",
        "O6779",
        "O6780",
        "O6781",
        "O6782",
        "O6783",
        "O6784",
        "O6785",
        "O6792",
        "O6793",
        "O6794",
        "O6795",
        "O6796",
        "O6797",
        "O6811",
        "O6815",
        "O6819",
        "O6820",
        "O6823",
        "O6825",
        "O6828",
        "O6829",
        "O6832",
        "O6833",
        "O6837",
        "O6841",
        "O6842",
        "O6848",
        "O6850",
        "O6852",
        "O6853",
        "O6854",
        "O6857",
        "O6859",
        "O6860",
        "O6862",
        "O6863",
        "O6864",
        "O6865",
        "O9741",
        "O9742",
        "O9748",
        "O9749",
        "O9752",
        "O9753",
        "O9825",
        "O9854"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 435,
            "lng": 285,
            "e13": 255,
            "mc": 240,
            "rb": 60,
            "vo": 90,
            "kas": 210,
            "dh": 15,
            "kes": 270,
            "vs": 30
          }
        }
      ]
    },
    {
      "descriptions": [
        "Dordrecht vanaf Dordtse brug tot Papendrechtse brug en Papendrecht"
      ],
      "berths": [
        "O844",
        "O885",
        "O894",
        "O975",
        "O978",
        "O4238",
        "O4314",
        "O4473",
        "O4892",
        "O4893",
        "O4894",
        "O4895",
        "O5023",
        "O6566",
        "O8034",
        "O8035",
        "O9512",
        "O9698",
        "O9699",
        "O9834",
        "O9849"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 540,
            "lng": 390,
            "e13": 360,
            "mc": 345,
            "rb": 60,
            "vo": 150,
            "kas": 270,
            "dh": 60,
            "kes": 330,
            "vs": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Kinderdijk"
      ],
      "berths": [
        "O818",
        "O4920",
        "O9778",
        "O9779",
        "O9803",
        "O9804"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 615,
            "lng": 465,
            "e13": 435,
            "mc": 420,
            "rb": 45,
            "vo": 270,
            "kas": 390,
            "dh": 150,
            "kes": 450,
            "vs": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Alblasserdam/Hendrik Ido Ambacht"
      ],
      "berths": [
        "O827",
        "O830",
        "O4255",
        "O4858",
        "O9788"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 495,
            "lng": 345,
            "e13": 315,
            "mc": 300,
            "rb": 60,
            "vo": 150,
            "kas": 270,
            "dh": 60,
            "kes": 330,
            "vs": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Sliedrecht"
      ],
      "berths": [
        "O945",
        "O964",
        "O4278",
        "O4451",
        "O4962"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 570,
            "lng": 420,
            "e13": 390,
            "mc": 375,
            "rb": 90,
            "vo": 180,
            "kas": 300,
            "dh": 90,
            "kes": 360,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Hardinxveld-Giessendam"
      ],
      "berths": [
        "O983",
        "O984",
        "O991",
        "O9710",
        "O9718"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 570,
            "lng": 420,
            "e13": 390,
            "mc": 375,
            "rb": 105,
            "vo": 195,
            "kas": 315,
            "dh": 105,
            "kes": 375,
            "vs": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "Gorinchem"
      ],
      "berths": [
        "O4458",
        "O4459",
        "O9757",
        "O9902"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 585,
            "lng": 435,
            "e13": 405,
            "mc": 390,
            "rb": 120,
            "vo": 210,
            "kas": 330,
            "dh": 120,
            "kes": 390,
            "vs": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Moerdijk"
      ],
      "berths": [
        "O819",
        "O859",
        "O862",
        "O916",
        "O922",
        "O930",
        "O947",
        "O968",
        "O4259",
        "O4320",
        "O4330",
        "O4340",
        "O4341",
        "O4342",
        "O4343",
        "O4436",
        "O4469",
        "O4930",
        "O4938",
        "O4939",
        "O5625",
        "O9515",
        "O9608",
        "O9622",
        "O9623",
        "O9624",
        "O9625",
        "O9626",
        "O9627",
        "O9628",
        "O9682",
        "O9683",
        "O9724",
        "O9727",
        "O9728",
        "O9729",
        "O9767",
        "O9768",
        "O9769",
        "O9799",
        "O9809",
        "O9824",
        "O9841",
        "O9860",
        "O9898"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 480,
            "lng": 330,
            "e13": 300,
            "mc": 285,
            "rb": 105,
            "vo": 60,
            "kas": 180,
            "dh": 60,
            "kes": 240,
            "vs": 45
          }
        }
      ]
    },
    {
      "descriptions": [
        "Dintelmond (Moerdijk Dintelmond)"
      ],
      "berths": [
        "O4855",
        "O4856"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 615,
            "lng": 465,
            "e13": 435,
            "mc": 420,
            "rb": 180,
            "vo": 60,
            "kas": 60,
            "dh": 135,
            "kes": 120,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Krimpen aan de Ijssel/Capelle aan de IJssel/Bolnes/Ridderkerk"
      ],
      "berths": [
        "G115",
        "G1000",
        "G1001",
        "G1002",
        "G1003",
        "G1004",
        "O4351",
        "O4426",
        "O4484",
        "O4867",
        "O9651",
        "O9652",
        "O9715",
        "O9716",
        "O9774",
        "O9785",
        "O9787",
        "O9798",
        "O9801",
        "O9802"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 510,
            "lng": 360,
            "e13": 330,
            "mc": 315,
            "rb": 15,
            "vo": 240,
            "kas": 360,
            "dh": 120,
            "kes": 420,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Ouderkerk"
      ],
      "berths": [
        "O9812"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 495,
            "lng": 345,
            "e13": 315,
            "mc": 300,
            "rb": 75,
            "vo": 300,
            "kas": 420,
            "dh": 180,
            "kes": 480,
            "vs": 180
          }
        }
      ]
    },
    {
      "descriptions": [
        "Barendrecht"
      ],
      "berths": [
        "O9737"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 375,
            "lng": 225,
            "e13": 195,
            "mc": 180,
            "rb": 105,
            "vo": 120,
            "kas": 240,
            "dh": 45,
            "kes": 300,
            "vs": 45
          }
        }
      ]
    },
    {
      "descriptions": [
        "Middelharnis"
      ],
      "berths": [
        "O842",
        "O9039"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 555,
            "lng": 405,
            "e13": 375,
            "mc": 360,
            "rb": 180,
            "vo": 90,
            "kas": 180,
            "dh": 150,
            "kes": 240,
            "vs": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Stellendam binnenkant"
      ],
      "berths": [
        "O9033",
        "O9035",
        "O9036"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 330,
            "lng": 195,
            "e13": 165,
            "mc": 150,
            "rb": 345,
            "vo": 150,
            "kas": 210,
            "dh": 210,
            "kes": 270,
            "vs": 195
          }
        }
      ]
    },
    {
      "descriptions": [
        "Stellendam buitenkant"
      ],
      "berths": [
        "O9032"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 300,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 415,
            "vo": 180,
            "kas": 240,
            "dh": 240,
            "kes": 300,
            "vs": 225
          }
        }
      ]
    },
    {
      "descriptions": [
        "Cruiseterminal-Maashaven-Parkkade e.o."
      ],
      "berths": [
        "G175",
        "G176",
        "G177",
        "G178",
        "G179",
        "G180",
        "G181",
        "G182",
        "G183",
        "G184",
        "G185",
        "G186",
        "G187",
        "G188",
        "G189",
        "G190",
        "G191",
        "G192",
        "G193",
        "G194",
        "G195",
        "G196",
        "G197",
        "G198",
        "G199",
        "G200",
        "G201",
        "G202",
        "G203",
        "G204",
        "G205",
        "G206",
        "G207",
        "G208",
        "G209",
        "G210",
        "G211",
        "G212",
        "G213",
        "G214",
        "G215",
        "G216",
        "G217",
        "G218",
        "G219",
        "G220",
        "G221",
        "G222",
        "G223",
        "G224",
        "G225",
        "G1242",
        "G1243",
        "G1244",
        "G1245",
        "G1246",
        "G1247",
        "G1248",
        "G1249",
        "G1250",
        "G1251",
        "G1252",
        "G1253",
        "G1254",
        "G1255",
        "G1256",
        "G1257",
        "G1258",
        "G1259",
        "G1260",
        "G1261",
        "G1262",
        "G1263",
        "G1264",
        "G1265",
        "G1266",
        "G1267",
        "G1268",
        "G1269",
        "G1270",
        "G1271",
        "G1272",
        "G1273",
        "G1274",
        "G1275",
        "G1276",
        "G1277",
        "G1278",
        "G1279",
        "G1280",
        "G1281",
        "G1282",
        "G1283",
        "G1284",
        "G1285",
        "G1286",
        "G1287",
        "G1288",
        "G1289",
        "G1290",
        "G1291",
        "G1292",
        "G1293",
        "G1294",
        "G1295",
        "G1296",
        "G1297",
        "G1298",
        "G1299",
        "G1300",
        "G1301",
        "G1302",
        "G1303",
        "G1304",
        "G1305",
        "G1306",
        "G1307",
        "G1308",
        "G1309",
        "G1310",
        "G1311",
        "G1312",
        "G1313",
        "G1314",
        "G1315",
        "G1316",
        "G1317",
        "G1318",
        "G1319",
        "G1320",
        "G1321",
        "G1322",
        "G1323",
        "G1324",
        "G1325",
        "G1326",
        "G1327",
        "G1328",
        "G1329",
        "G1330",
        "G1331",
        "G1332",
        "G1333",
        "G1334",
        "G1335",
        "G1336",
        "G1337",
        "G1338",
        "G1339",
        "G1340",
        "G1341",
        "G1342",
        "G1343",
        "G1344",
        "G1345",
        "G1346",
        "G1347",
        "G1348",
        "G1349",
        "G1350",
        "G1351",
        "G1352",
        "G1353",
        "G1354",
        "G1355",
        "G1356",
        "G1357",
        "G1358",
        "G1359",
        "G1360",
        "G1361",
        "G1362",
        "G1363",
        "G1364",
        "G1365",
        "G1366",
        "G1367",
        "G1368",
        "G1369",
        "G1370",
        "G1371",
        "G1372",
        "G1373",
        "G1374",
        "G1375",
        "G1376",
        "G1377",
        "G1378",
        "G1379",
        "G1380",
        "G1381",
        "G1382",
        "G1383",
        "G1384",
        "G1385",
        "G1386",
        "G1387",
        "G1388",
        "G1389",
        "G1390",
        "G1391",
        "G1392",
        "G1393",
        "G1394",
        "G1395",
        "G1396",
        "G1397",
        "G1398",
        "G1399",
        "G1400",
        "G1401",
        "G1402",
        "G1403",
        "G1404",
        "G1405",
        "G1406",
        "G1407",
        "G1408",
        "G1409",
        "G1410",
        "G1411",
        "G1412",
        "G1413",
        "G1414",
        "G1415",
        "G1416",
        "G1417",
        "G1418",
        "G1419",
        "G1420",
        "G1421",
        "G1422",
        "G1423",
        "G1424",
        "G1425",
        "G1426",
        "G1427",
        "G1428",
        "G1429",
        "G1430",
        "G1431",
        "G1432",
        "G1433",
        "G1434",
        "G1435",
        "G1436",
        "G1437",
        "G1438",
        "G1439",
        "G1440",
        "G1441",
        "G1442",
        "G1443",
        "G1444",
        "G1445",
        "G1446",
        "G1447",
        "G1448",
        "G1449",
        "G1450",
        "G1451",
        "G1452",
        "G1453",
        "G1454",
        "G1455",
        "G1456",
        "G1457",
        "G1458",
        "G1459",
        "G1460",
        "G1461",
        "G1462",
        "G1463",
        "G1464",
        "G1465",
        "G1466",
        "G1467",
        "G1468",
        "G1469",
        "G1470",
        "G1471",
        "G1472",
        "G1473",
        "G1474",
        "G1475",
        "G1476",
        "G1477",
        "G1478",
        "G1479",
        "G1480",
        "G1481",
        "G1482",
        "G1483",
        "G1484",
        "G1485",
        "G1486",
        "G1487",
        "G1488",
        "G1489",
        "G1490",
        "G1491",
        "G1492",
        "G1493",
        "G1494",
        "G1495",
        "G1496",
        "G1497",
        "G1498",
        "G1499",
        "G1500",
        "G1501",
        "G1502",
        "G1503",
        "G1504",
        "G1505",
        "G1506",
        "G1507",
        "G1508",
        "G1509",
        "G1510",
        "G1511",
        "G1512",
        "G1513",
        "G1514",
        "G1515",
        "G1516",
        "G1517",
        "G1518",
        "G1519",
        "G1520",
        "G1521",
        "G1522",
        "G1523",
        "G1524",
        "G1525",
        "G1526",
        "G1527",
        "G1528",
        "G1529",
        "G1530",
        "G1531",
        "G1532",
        "G1533",
        "G1534",
        "G1535",
        "G1536",
        "G1537",
        "G1538",
        "G1539",
        "G1540",
        "G1541",
        "G1542",
        "G1543",
        "G1544",
        "G1545",
        "G1546",
        "G1547",
        "G1548",
        "G1549",
        "G1550",
        "G1551",
        "G1552",
        "G1553",
        "G1554",
        "G1555",
        "G1556",
        "G1557",
        "G1558",
        "G1559",
        "G1560",
        "G1561",
        "G1562",
        "G1563",
        "G1564",
        "G1565",
        "G1566",
        "G1567",
        "G1568",
        "G1569",
        "G1570",
        "G1571",
        "G1572",
        "G1573",
        "G1574",
        "G1575",
        "G1576",
        "G1577",
        "G1578",
        "G1579",
        "G1580",
        "G1581",
        "G1582",
        "G1583",
        "G1584",
        "G1585",
        "G1586",
        "G1587",
        "G1588",
        "G1589",
        "G1590",
        "G1591",
        "G1592",
        "G1593",
        "G1594",
        "G1595",
        "G1596",
        "G1597",
        "G1598",
        "G1599",
        "G1600",
        "G1601",
        "G1602",
        "G1603",
        "G1604",
        "G1605",
        "G1606",
        "G1607",
        "G1608",
        "G1609",
        "G1610",
        "G1611",
        "G1612",
        "G1613",
        "G1614",
        "G1615",
        "G1616",
        "G1617",
        "G1618",
        "G1619",
        "G1620",
        "G1621",
        "G1622",
        "G1623",
        "G1624",
        "G1625",
        "G1626",
        "G1627",
        "G1628",
        "G1629",
        "G1630",
        "G1631",
        "G1632",
        "G1633",
        "G1634",
        "G1635",
        "G1636",
        "G1637",
        "G1638",
        "G1639",
        "G1640",
        "G1641",
        "G1642",
        "G1643",
        "G1644",
        "G1645",
        "G1646",
        "G1647",
        "G1648",
        "G1649",
        "G1650",
        "G1651",
        "G1652",
        "G1653",
        "G1654",
        "G1655",
        "G1656",
        "G1657",
        "G1658",
        "G1659",
        "G1660",
        "G1661",
        "G1662",
        "G1663",
        "G1664",
        "G1665",
        "G1666",
        "G1667",
        "G1668",
        "G1669",
        "G1670",
        "G1671",
        "G1672",
        "G1673",
        "G1674",
        "G1675",
        "G1676",
        "G1677",
        "G1678",
        "G1679",
        "G1680",
        "G1681",
        "G1682",
        "G1683",
        "G1684",
        "G1685",
        "G1686",
        "G1687",
        "G1688",
        "G1689",
        "G1690",
        "G1691",
        "G1692",
        "G1693",
        "G1694",
        "G1695",
        "G1696",
        "G1697",
        "G1698",
        "G1699",
        "G1700",
        "G1701",
        "G1702",
        "G1703",
        "G1704",
        "G1705",
        "G1706",
        "G1707",
        "G1708",
        "G1709",
        "G1710",
        "G1711",
        "G1712",
        "G1713",
        "G1714",
        "G1715",
        "G1716",
        "G1717",
        "G1718",
        "G1719",
        "G1720",
        "G1721",
        "G1722",
        "G1723",
        "G1724",
        "G1725",
        "G1726",
        "G1727",
        "G1728",
        "G1729",
        "G1730",
        "G1731",
        "G1732",
        "G1733",
        "G1734",
        "G1735",
        "G1736",
        "G1737",
        "G1738",
        "G1739",
        "G1740",
        "G1741",
        "G1742",
        "G1743",
        "G1744",
        "G1745",
        "G1746",
        "G1747",
        "G1748",
        "G1749",
        "G1750",
        "G1751",
        "G1752",
        "G1753",
        "G1754",
        "G1755",
        "G1756",
        "G1757",
        "G1758",
        "G1759",
        "G1760",
        "G1761",
        "G1762",
        "G1763",
        "G1764",
        "G1765",
        "G1766",
        "G1767",
        "G1768",
        "G1769",
        "G1770",
        "G1771",
        "G1772",
        "G1773",
        "G1774",
        "G1775",
        "G1776",
        "G1777",
        "G1778",
        "G1779",
        "G1780",
        "G1781",
        "G1782",
        "G1783",
        "G1784",
        "G1785",
        "G1786",
        "G1787",
        "G1788",
        "G1789",
        "G1790",
        "G1791",
        "G1792",
        "G1793",
        "G1794",
        "G1795",
        "G1796",
        "G1797",
        "G1798",
        "G1799",
        "G1800",
        "G1801",
        "G1802",
        "G1803",
        "G1804",
        "G1805",
        "G1806",
        "G1807",
        "G1808",
        "G1809",
        "G1810",
        "G1811",
        "G1812",
        "G1813",
        "G1814",
        "G1815",
        "G1816",
        "G1817",
        "G1818",
        "G1819",
        "G1820",
        "G1821",
        "G1822",
        "G1823",
        "G1824",
        "G1825",
        "G1826",
        "G1827",
        "G1828",
        "G1829",
        "G1830",
        "G1831",
        "G1832",
        "G1833",
        "G1834",
        "G1835",
        "G1836",
        "G1837",
        "G1838",
        "G1839",
        "G1840",
        "G1841",
        "G1842",
        "G1843",
        "G1844",
        "G1845",
        "G1846",
        "G1847",
        "G1848",
        "G1849",
        "G1850",
        "G1851",
        "G1852",
        "G1853",
        "G1854",
        "G1855",
        "G1856",
        "G1857",
        "G1858",
        "G1859",
        "G1860",
        "G1861",
        "G1862",
        "G1863",
        "G1864",
        "G1865",
        "G1866",
        "G1867",
        "G1868",
        "G1869",
        "G1870",
        "G1871",
        "G1872",
        "G1873",
        "G1874",
        "G1875",
        "G1876",
        "G1877",
        "G1878",
        "G1879",
        "G1880",
        "G1881",
        "G1882",
        "G1883",
        "G1884",
        "G1885",
        "G1886",
        "G1887",
        "G1888",
        "G1889",
        "G1890",
        "G1891",
        "G1892",
        "G1893",
        "G1894",
        "G1895",
        "G1896",
        "G1897",
        "G1898",
        "G1899",
        "G1900",
        "G1901",
        "G1902",
        "G1903",
        "G1904",
        "G1905",
        "G1906",
        "G1907",
        "G1908",
        "G1909",
        "G1910",
        "G1911",
        "G1912",
        "G1913",
        "G1914",
        "G1915",
        "G1916",
        "G1917",
        "G1918",
        "G1919",
        "G1920",
        "G1921",
        "G1922",
        "G1923",
        "G1924",
        "G1925",
        "G1926",
        "G1927",
        "G1928",
        "G1929",
        "G1930",
        "G1931",
        "G1932",
        "G1933",
        "G1934",
        "G1935",
        "G1936",
        "G1937",
        "G1938",
        "G1939",
        "G1940",
        "G1941",
        "G1942",
        "G1943",
        "G1944",
        "G1945",
        "G1946",
        "G1947",
        "G1948",
        "G1949",
        "G1950",
        "G1951",
        "G1952",
        "G1953",
        "G1954",
        "G1955",
        "G1956",
        "G1957",
        "G1958",
        "G1959",
        "G1960",
        "G1961",
        "G1962",
        "G1963",
        "G1964",
        "G1965",
        "G1966",
        "G1967",
        "G1968",
        "G1969",
        "G1970",
        "G1971",
        "G1972",
        "G1973",
        "G1974",
        "G1975",
        "G1976",
        "G1977",
        "G1978",
        "G1979",
        "G1980",
        "G1981",
        "G1982",
        "G1983",
        "G1984",
        "G1985",
        "G1986",
        "G1987",
        "G1988",
        "G1989",
        "G1990",
        "G1991",
        "G1992",
        "G1993",
        "G1994",
        "G1995",
        "G1996",
        "G1997",
        "G1998",
        "G1999",
        "G2000",
        "G2001",
        "G2002",
        "G2003",
        "G2004",
        "G2005",
        "G2006",
        "G2007",
        "G2008",
        "G2009",
        "G2010",
        "G2011",
        "G2012",
        "G2013",
        "G2014",
        "G2015",
        "G2016",
        "G2017",
        "G2018",
        "G2019",
        "G2020",
        "G2021",
        "G2022",
        "G2023",
        "G2024",
        "G2025",
        "G2026",
        "G2027",
        "G2028",
        "G2029",
        "G2030",
        "G2031",
        "G2032",
        "G2033",
        "G2034",
        "G2035",
        "G2036",
        "G2037",
        "G2038",
        "G2039",
        "G2040",
        "G2041",
        "G2042",
        "G2043",
        "G2044",
        "G2045",
        "G2046",
        "G2047",
        "G2048",
        "G2049",
        "G2050",
        "G2051",
        "G2052",
        "G2053",
        "G2054",
        "G2055",
        "G2056",
        "G2057",
        "G2058",
        "G2059",
        "G2060",
        "G2061",
        "G2062",
        "G2063",
        "G2064",
        "G2065",
        "G2066",
        "G2067",
        "G2068",
        "G2069",
        "G2070",
        "G2071",
        "G2072",
        "G2073",
        "G2074",
        "G2075",
        "G2076",
        "G2077",
        "G2078",
        "G2079",
        "G2080",
        "G2081",
        "G2082",
        "G2083",
        "G2084",
        "G2085",
        "G2086",
        "G2087",
        "G2088",
        "G2089",
        "G2090",
        "G2091",
        "G2092",
        "G2093",
        "G2094",
        "G2095",
        "G2096",
        "G2097",
        "G2098",
        "G2099",
        "G2100",
        "G2101",
        "G2102",
        "G2103",
        "G2104",
        "G2105",
        "G2106",
        "G2107",
        "G2108",
        "G2109",
        "G2110",
        "G2111",
        "G2112",
        "G2113",
        "G2114",
        "G2115",
        "G2116",
        "G2117",
        "G2118",
        "G2119",
        "G2120"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 390,
            "lng": 240,
            "e13": 210,
            "mc": 195,
            "rb": 30,
            "vo": 210,
            "kas": 330,
            "dh": 135,
            "kes": 390,
            "vs": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Waalhaven-Merwehaven"
      ],
      "berths": [
        "G13",
        "G14",
        "G15",
        "G16",
        "G17",
        "G18",
        "G19",
        "G20",
        "G21",
        "G22",
        "G23",
        "G24",
        "G25",
        "G26",
        "G27",
        "G28",
        "G29",
        "G30",
        "G31",
        "G32",
        "G33",
        "G34",
        "G226",
        "G227",
        "G228",
        "G229",
        "G230",
        "G231",
        "G232",
        "G233",
        "G234",
        "G235",
        "G236",
        "G237",
        "G238",
        "G239",
        "G240",
        "G241",
        "G242",
        "G243",
        "G244",
        "G245",
        "G246",
        "G247",
        "G248",
        "G249",
        "G250",
        "G251",
        "G252",
        "G253",
        "G254",
        "G255",
        "G256",
        "G257",
        "G258",
        "G259",
        "G260",
        "G261",
        "G262",
        "G263",
        "G264",
        "G265",
        "G266",
        "G267",
        "G268",
        "G269",
        "G270",
        "G271",
        "G272",
        "G273",
        "G274",
        "G275",
        "G276",
        "G277",
        "G278",
        "G279",
        "G280",
        "G281",
        "G282",
        "G283",
        "G284",
        "G285",
        "G286",
        "G287",
        "G288",
        "G289",
        "G290",
        "G291",
        "G292",
        "G293",
        "G294",
        "G295",
        "G296",
        "G297",
        "G298",
        "G299",
        "G300",
        "G301",
        "G302",
        "G303",
        "G304",
        "G305",
        "G306",
        "G307",
        "G308",
        "G309",
        "G310",
        "G311",
        "G312",
        "G313",
        "G314",
        "G315",
        "G316",
        "G317",
        "G318",
        "G319",
        "G320",
        "G321",
        "G322",
        "G323",
        "G324",
        "G325",
        "G326",
        "G327",
        "G328",
        "G329",
        "G330",
        "G331",
        "G332",
        "G333",
        "G334",
        "G335",
        "G336",
        "G337",
        "G338",
        "G339",
        "G340",
        "G341",
        "G342",
        "G343",
        "G344",
        "G345",
        "G346",
        "G347",
        "G348",
        "G349",
        "G350",
        "G351",
        "G352",
        "G353",
        "G354",
        "G355",
        "G356",
        "G357",
        "G358",
        "G359",
        "G360",
        "G361",
        "G362",
        "G363",
        "G364",
        "G365",
        "G366",
        "G367",
        "G368",
        "G369",
        "G370",
        "G371",
        "G372",
        "G373",
        "G374",
        "G375",
        "G376",
        "G377",
        "G378",
        "G379",
        "G380",
        "G381",
        "G382",
        "G383",
        "G384",
        "G385",
        "G386",
        "G387",
        "G388",
        "G389",
        "G390",
        "G391",
        "G392",
        "G393",
        "G394",
        "G395",
        "G396",
        "G397",
        "G398",
        "G399",
        "G400",
        "G401",
        "G402",
        "G403",
        "G404",
        "G405",
        "G406",
        "G407",
        "G408",
        "G409",
        "G410",
        "G411",
        "G412",
        "G413",
        "G414",
        "G415",
        "G416",
        "G2121",
        "G2122",
        "G2123",
        "G2124",
        "G2125",
        "G2126",
        "G2127",
        "G2128",
        "G2129",
        "G2130",
        "G2131",
        "G2132",
        "G2133",
        "G2134",
        "G2135",
        "G2136",
        "G2137",
        "G2138",
        "G2139",
        "G2140",
        "G2141",
        "G2142",
        "G2143",
        "G2144",
        "G2145",
        "G2146",
        "G2147",
        "G2148",
        "G2149",
        "G2150",
        "G2151",
        "G2152",
        "G2153",
        "G2154",
        "G2155",
        "G2156",
        "G2157",
        "G2158",
        "G2159",
        "G2160",
        "G2161",
        "G2162",
        "G2163",
        "G2164",
        "G2165",
        "G2166",
        "G2167",
        "G2168",
        "G2169",
        "G2170",
        "G2171",
        "G2172",
        "G2173",
        "G2174",
        "G2175",
        "G2176",
        "G2177",
        "G2178",
        "G2179",
        "G2180",
        "G2181",
        "G2182",
        "G2183",
        "G2184",
        "G2185",
        "G2186",
        "G2187",
        "G2188",
        "G2189",
        "G2190",
        "G2191",
        "G2192",
        "G2193",
        "G2194",
        "G2195",
        "G2196",
        "G2197",
        "G2198",
        "G2199",
        "G2200",
        "G2201",
        "G2202",
        "G2203",
        "G2204",
        "G2205",
        "G2206",
        "G2207",
        "G2208",
        "G2209",
        "G2210",
        "G2211",
        "G2212",
        "G2213",
        "G2214",
        "G2215",
        "G2216",
        "G2217",
        "G2218",
        "G2219",
        "G2220",
        "G2221",
        "G2222",
        "G2223",
        "G2224",
        "G2225",
        "G2226",
        "G2227",
        "G2228",
        "G2229",
        "G2230",
        "G2231",
        "G2232",
        "G2233",
        "G2234",
        "G2235",
        "G2236",
        "G2237",
        "G2238",
        "G2239",
        "G2240",
        "G2241",
        "G2242",
        "G2243",
        "G2244",
        "G2245",
        "G2246",
        "G2247",
        "G2248",
        "G2249",
        "G2250",
        "G2251",
        "G2252",
        "G2253",
        "G2254",
        "G2255",
        "G2256",
        "G2257",
        "G2258",
        "G2259",
        "G2260",
        "G2261",
        "G2262",
        "G2263",
        "G2264",
        "G2265",
        "G2266",
        "G2267",
        "G2268",
        "G2269",
        "G2270",
        "G2271",
        "G2272",
        "G2273",
        "G2274",
        "G2275",
        "G2276",
        "G2277",
        "G2278",
        "G2279",
        "G2280",
        "G2281",
        "G2282",
        "G2283",
        "G2284",
        "G2285",
        "G2286",
        "G2287",
        "G2288",
        "G2289",
        "G2290",
        "G2291",
        "G2292",
        "G2293",
        "G2294",
        "G2295",
        "G2296",
        "G2297",
        "G2298",
        "G2299",
        "G2300",
        "G2301",
        "G2302",
        "G2303",
        "G2304",
        "G2305",
        "G2306",
        "G2307",
        "G2308",
        "G2309",
        "G2310",
        "G2311",
        "G2312",
        "G2313",
        "G2314",
        "G2315",
        "G2316",
        "G2317",
        "G2318",
        "G2319",
        "G2320",
        "G2321",
        "G2322",
        "G2323",
        "G2324",
        "G2325",
        "G2326",
        "G2327",
        "G2328",
        "G2329",
        "G2330",
        "G2331",
        "G2332",
        "G2333",
        "G2334",
        "G2335",
        "G2336",
        "G2337",
        "G2338",
        "G2339",
        "G2340",
        "G2341",
        "G2342",
        "G2343",
        "G2344",
        "G2345",
        "G2346",
        "G2347",
        "G2348",
        "G2349",
        "G2350",
        "G2351",
        "G2352",
        "G2353",
        "G2354",
        "G2355",
        "G2356",
        "G2357",
        "G2358",
        "G2359",
        "G2360",
        "G2361",
        "G2362",
        "G2363",
        "G2364",
        "G2365",
        "G2366",
        "G2367",
        "G2368",
        "G2369",
        "G2370",
        "G2371",
        "G2372",
        "G2373",
        "G2374",
        "G2375",
        "G2376",
        "G2377",
        "G2378",
        "G2379",
        "G2380",
        "G2381",
        "G2382",
        "G2383",
        "G2384",
        "G2385",
        "G2386",
        "G2387",
        "G2388",
        "G2389",
        "G2390",
        "G2391",
        "G2392",
        "G2393",
        "G2394",
        "G2395",
        "G2396",
        "G2397",
        "G2398",
        "G2399",
        "G2400",
        "G2401",
        "G2402",
        "G2403",
        "G2404",
        "G2405",
        "G2406",
        "G2407",
        "G2408",
        "G2409",
        "G2410",
        "G2411",
        "G2412",
        "G2413",
        "G2414",
        "G2415",
        "G2416",
        "G2417",
        "G2418",
        "G2419",
        "G2420",
        "G2421",
        "G2422",
        "G2423",
        "G2424",
        "G2425",
        "G2426",
        "G2427",
        "G2428",
        "G2429",
        "G2430",
        "G2431",
        "G2432",
        "G2433",
        "G2434",
        "G2435",
        "G2436",
        "G2437",
        "G2438",
        "G2439",
        "G2440",
        "G2441",
        "G2442",
        "G2443",
        "G2444",
        "G2445",
        "G2446",
        "G2447",
        "G2448",
        "G2449",
        "G2450",
        "G2451",
        "G2452",
        "G2453",
        "G2454",
        "G2455",
        "G2456",
        "G2457",
        "G2458",
        "G2459",
        "G2460",
        "G2461",
        "G2462",
        "G2463",
        "G2464",
        "G2465",
        "G2466",
        "G2467",
        "G2468",
        "G2469",
        "G2470",
        "G2471",
        "G2472",
        "G2473",
        "G2474",
        "G2475",
        "G2476",
        "G2477",
        "G2478",
        "G2479",
        "G2480",
        "G2481",
        "G2482",
        "G2483",
        "G2484",
        "G2485",
        "G2486",
        "G2487",
        "G2488",
        "G2489",
        "G2490",
        "G2491",
        "G2492",
        "G2493",
        "G2494",
        "G2495",
        "G2496",
        "G2497",
        "G2498",
        "G2499",
        "G2500",
        "G2501",
        "G2502",
        "G2503",
        "G2504",
        "G2505",
        "G2506",
        "G2507",
        "G2508",
        "G2509",
        "G2510",
        "G2511",
        "G2512",
        "G2513",
        "G2514",
        "G2515",
        "G2516",
        "G2517",
        "G2518",
        "G2519",
        "G2520",
        "G2521",
        "G2522",
        "G2523",
        "G2524",
        "G2525",
        "G2526",
        "G2527",
        "G2528",
        "G2529",
        "G2530",
        "G2531",
        "G2532",
        "G2533",
        "G2534",
        "G2535",
        "G2536",
        "G2537",
        "G2538",
        "G2539",
        "G2540",
        "G2541",
        "G2542",
        "G2543",
        "G2544",
        "G2545",
        "G2546",
        "G2547",
        "G2548",
        "G2549",
        "G2550",
        "G2551",
        "G2552",
        "G2553",
        "G2554",
        "G2555",
        "G2556",
        "G2557",
        "G2558",
        "G2559",
        "G2560",
        "G2561",
        "G2562",
        "G2563",
        "G2564",
        "G2565",
        "G2566",
        "G2567",
        "G2568",
        "G2569",
        "G2570",
        "G2571",
        "G2572",
        "G2573",
        "G2574",
        "G2575",
        "G2576",
        "G2577",
        "G2578",
        "G2579",
        "G2580",
        "G2581",
        "G2582",
        "G2583",
        "G2584",
        "G2585",
        "G2586",
        "G2587",
        "G2588",
        "G2589",
        "G2590",
        "G2591",
        "G2592",
        "G2593",
        "G2594",
        "G2595",
        "G2596",
        "G2597",
        "G2598",
        "G2599",
        "G2600",
        "G2601",
        "G2602",
        "G2603",
        "G2604",
        "G2605",
        "G2606",
        "G2607",
        "G2608",
        "G2609",
        "G2610",
        "G2611",
        "G2612",
        "G2613",
        "G2614",
        "G2615",
        "G2616",
        "G2617",
        "G2618",
        "G2619",
        "G2620",
        "G2621",
        "G2622",
        "G2623",
        "G2624",
        "G2625",
        "G2626",
        "G2627",
        "G2628",
        "G2629",
        "G2630",
        "G2631",
        "G2632",
        "G2633",
        "G2634",
        "G2635"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<15000"
          },
          "minutesFrom": {
            "rv": 375,
            "lng": 225,
            "e13": 195,
            "mc": 180,
            "rb": 45,
            "vo": 195,
            "kas": 315,
            "dh": 120,
            "kes": 375,
            "vs": 135
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=15000"
          },
          "minutesFrom": {
            "rv": 390,
            "lng": 240,
            "e13": 210,
            "mc": 195
          }
        }
      ]
    },
    {
      "descriptions": [
        "Eemhaven-Wiltonhaven-Wilhelminahaven"
      ],
      "berths": [
        "G501",
        "G502",
        "G503",
        "G504",
        "G505",
        "G506",
        "G507",
        "G508",
        "G509",
        "G510",
        "G511",
        "G512",
        "G513",
        "G514",
        "G515",
        "G516",
        "G517",
        "G518",
        "G519",
        "G520",
        "G521",
        "G522",
        "G523",
        "G524",
        "G525",
        "G526",
        "G527",
        "G528",
        "G529",
        "G530",
        "G531",
        "G532",
        "G533",
        "G534",
        "G535",
        "G536",
        "G537",
        "G538",
        "G539",
        "G540",
        "G541",
        "G542",
        "G543",
        "G544",
        "G545",
        "G546",
        "G547",
        "G548",
        "G549",
        "G550",
        "G551",
        "G552",
        "G553",
        "G554",
        "G555",
        "G556",
        "G557",
        "G558",
        "G559",
        "G560",
        "G561",
        "G562",
        "G563",
        "G564",
        "G565",
        "G566",
        "G567",
        "G568",
        "G569",
        "G570",
        "G571",
        "G572",
        "G573",
        "G574",
        "G575",
        "G576",
        "G577",
        "G578",
        "G579",
        "G580",
        "G2636",
        "G2637",
        "G2638",
        "G2639",
        "G2640",
        "G2641",
        "G2642",
        "G2643",
        "G2644",
        "G2645",
        "G2646",
        "G2647",
        "G2648",
        "G2649",
        "G2650",
        "G2651",
        "G2652",
        "G2653",
        "G2654",
        "G2655",
        "G2656",
        "G2657",
        "G2658",
        "G2659",
        "G2660",
        "G2661",
        "G2662",
        "G2663",
        "G2664",
        "G2665",
        "G2666",
        "G2667",
        "G2668",
        "G2669",
        "G2670",
        "G2671",
        "G2672",
        "G2673",
        "G2674",
        "G2675",
        "G2676",
        "G2677",
        "G2678",
        "G2679",
        "G2680",
        "G2681",
        "G2682",
        "G2683",
        "G2684",
        "G2685",
        "G2686",
        "G2687",
        "G2688",
        "G2689",
        "G2690",
        "G2691",
        "G2692",
        "G2693",
        "G2694",
        "G2695",
        "G2696",
        "G2697",
        "G2698",
        "G2699",
        "G2700",
        "G2701",
        "G2702",
        "G2703",
        "G2704",
        "G2705",
        "G2706",
        "G2707",
        "G2708",
        "G2709",
        "G2710",
        "G2711",
        "G2712",
        "G2713",
        "G2714",
        "G2715",
        "G2716",
        "G2717",
        "G2718",
        "G2719",
        "G2720",
        "G2721",
        "G2722",
        "G2723",
        "G2724",
        "G2725",
        "G2726",
        "G2727",
        "G2728",
        "G2729",
        "G2730",
        "G2731",
        "G2732",
        "G2733",
        "G2734",
        "G2735",
        "G2736",
        "G2737",
        "G2738",
        "G2739",
        "G2740",
        "G2741",
        "G2742",
        "G2743",
        "G2744",
        "G2745",
        "G2746",
        "G2747",
        "G2748",
        "G2749",
        "G2750",
        "G2751",
        "G2752",
        "G2753",
        "G2754",
        "G2755",
        "G2756",
        "G2757",
        "G2758",
        "G2759",
        "G2760",
        "G2761",
        "G2762",
        "G2763",
        "G2764",
        "G2765",
        "G2766",
        "G2767",
        "G2768",
        "G2769",
        "G2770",
        "G2771",
        "G2772",
        "G2773",
        "G2774",
        "G2775",
        "G2776",
        "G2777",
        "G2778",
        "G2779",
        "G2780",
        "G2781",
        "G2782",
        "G2783",
        "G2784",
        "G2785",
        "G2786",
        "G2787",
        "G2788",
        "G2789",
        "G2790",
        "G2791",
        "G2792",
        "G2793",
        "G2794",
        "G2795",
        "G2796",
        "G2797",
        "G2798",
        "G2799",
        "G2800",
        "G2801",
        "G2802",
        "G2803",
        "G2804",
        "G2805",
        "G2806",
        "G2807",
        "G2808",
        "G2809",
        "G2810",
        "G2811",
        "G2812",
        "G2813",
        "G2814",
        "G2815",
        "G2816",
        "G2817",
        "G2818",
        "G2819",
        "G2820",
        "G2821",
        "G2822",
        "G2823",
        "G2824",
        "G2825",
        "G2826",
        "G2827",
        "G2828",
        "G2829",
        "G2830",
        "G2831",
        "G2832",
        "G2833",
        "G2834",
        "G2835",
        "G2836",
        "G2837",
        "G2838",
        "G2839",
        "G2840",
        "G2841",
        "G2842",
        "G2843",
        "G2844",
        "G2845",
        "G2846",
        "G2847",
        "G2848",
        "G2849",
        "G2850",
        "G2851",
        "G2852",
        "G2853",
        "G2854",
        "G2855",
        "G2856",
        "G2857",
        "G2858",
        "G2859",
        "G2860",
        "G2861",
        "G2862",
        "G2863",
        "G2864",
        "G2865",
        "G2866",
        "G2867",
        "G2868",
        "G2869",
        "G2870",
        "G2871",
        "G2872",
        "G2873",
        "G2874",
        "G2875",
        "G2876",
        "G2877",
        "G2878",
        "G2879",
        "G2880",
        "G2881",
        "G2882",
        "G2883",
        "G2884",
        "G2885",
        "G2886",
        "G2887",
        "G2888",
        "G2889",
        "G2890",
        "G2891",
        "G2892",
        "G2893",
        "G2894",
        "G2895",
        "G2896",
        "G2897",
        "G2898",
        "G2899",
        "G2900",
        "G2901",
        "G2902",
        "G2903",
        "G2904",
        "G2905",
        "G2906",
        "G2907",
        "G2908",
        "G2909",
        "G2910",
        "G2911",
        "G2912",
        "G2913",
        "G2914",
        "G2915",
        "G2916",
        "G2917",
        "G2918",
        "G2919",
        "G2920",
        "G2921",
        "G2922",
        "G2923",
        "G2924",
        "G2925",
        "G2926",
        "G2927",
        "G2928",
        "G2929",
        "G2930",
        "G2931",
        "G2932",
        "G2933",
        "G2934",
        "G2935",
        "G2936",
        "G2937",
        "G2938",
        "G2939",
        "G2940",
        "G2941",
        "G2942",
        "G2943",
        "G2944",
        "G2945",
        "G2946",
        "G2947",
        "G2948",
        "G2949",
        "G2950",
        "G2951",
        "G2952",
        "G2953",
        "G2954",
        "G2955",
        "G2956",
        "G2957",
        "G2958",
        "G2959",
        "G2960",
        "G2961",
        "G2962",
        "G2963",
        "G2964",
        "G2965",
        "G2966",
        "G2967",
        "G2968",
        "G2969",
        "G2970",
        "G2971",
        "G2972",
        "G2973",
        "G2974",
        "G2975",
        "G2976",
        "G2977",
        "G2978",
        "G2979",
        "G2980",
        "G2981",
        "G2982",
        "G2983",
        "G2984",
        "G2985",
        "G2986",
        "G2987",
        "G2988",
        "G2989",
        "G2990",
        "G2991",
        "G2992",
        "G2993",
        "G2994",
        "G2995",
        "G2996",
        "G2997",
        "G2998",
        "G2999",
        "G3000",
        "O4304",
        "O4303",
        "O915",
        "O9792"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<15000"
          },
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150,
            "rb": 60,
            "vo": 180,
            "kas": 300,
            "dh": 120,
            "kes": 360,
            "vs": 135
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=15000"
          },
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165
          }
        }
      ]
    },
    {
      "descriptions": [
        "2e Pet-Vulcaanhaven-KW Haven"
      ],
      "berths": [
        "G581",
        "G582",
        "G583",
        "G584",
        "G585",
        "G586",
        "G587",
        "G588",
        "G589",
        "G590",
        "G591",
        "G592",
        "G593",
        "G594",
        "G595",
        "G596",
        "G597",
        "G598",
        "G599",
        "G600",
        "G601",
        "G602",
        "G603",
        "G604",
        "G605",
        "G606",
        "G607",
        "G608",
        "G609",
        "G610",
        "G611",
        "G612",
        "G613",
        "G614",
        "G615",
        "G616",
        "G617",
        "G618",
        "G619",
        "G620",
        "G621",
        "G622",
        "G623",
        "G624",
        "G625",
        "G626",
        "G627",
        "G628",
        "G629",
        "G630",
        "G631",
        "G632",
        "G633",
        "G634",
        "G635",
        "G636",
        "G637",
        "G638",
        "G639",
        "G640",
        "G641",
        "G642",
        "G643",
        "G644",
        "G645",
        "G646",
        "G647",
        "G648",
        "G649",
        "G650",
        "G651",
        "G652",
        "G653",
        "G654",
        "G655",
        "G656",
        "G657",
        "G658",
        "G659",
        "G660",
        "G661",
        "G662",
        "G663",
        "G664",
        "G665",
        "G666",
        "G667",
        "G668",
        "G669",
        "G670",
        "G671",
        "G672",
        "G673",
        "G674",
        "G675",
        "G676",
        "G677",
        "G678",
        "G679",
        "G680",
        "G681",
        "G682",
        "G683",
        "G684",
        "G685",
        "G686",
        "G687",
        "G688",
        "G689",
        "G690",
        "G691",
        "G692",
        "G693",
        "G694",
        "G695",
        "G696",
        "G697",
        "G698",
        "G699",
        "G700",
        "G701",
        "G702",
        "G703",
        "G704",
        "G705",
        "G706",
        "G707",
        "G708",
        "G3001",
        "G3002",
        "G3003",
        "G3004",
        "G3005",
        "G3006",
        "G3007",
        "G3008",
        "G3009",
        "G3010",
        "G3011",
        "G3012",
        "G3013",
        "G3014",
        "G3015",
        "G3016",
        "G3017",
        "G3018",
        "G3019",
        "G3020",
        "G3021",
        "G3022",
        "G3023",
        "G3024",
        "G3025",
        "G3026",
        "G3027",
        "G3028",
        "G3029",
        "G3030",
        "G3031",
        "G3032",
        "G3033",
        "G3034",
        "G3035",
        "G3036",
        "G3037",
        "G3038",
        "G3039",
        "G3040",
        "G3041",
        "G3042",
        "G3043",
        "G3044",
        "G3045",
        "G3046",
        "G3047",
        "G3048",
        "G3049",
        "G3050",
        "G3051",
        "G3052",
        "G3053",
        "G3054",
        "G3055",
        "G3056",
        "G3057",
        "G3058",
        "G3059",
        "G3060",
        "G3061",
        "G3062",
        "G3063",
        "G3064",
        "G3065",
        "G3066",
        "G3067",
        "G3068",
        "G3069",
        "G3070",
        "G3071",
        "G3072",
        "G3073",
        "G3074",
        "G3075",
        "G3076",
        "G3077",
        "G3078",
        "G3079",
        "G3080",
        "G3081",
        "G3082",
        "G3083",
        "G3084",
        "G3085",
        "G3086",
        "G3087",
        "G3088",
        "G3089",
        "G3090",
        "G3091",
        "G3092",
        "G3093",
        "G3094",
        "G3095",
        "G3096",
        "G3097",
        "G3098",
        "G3099",
        "G3100",
        "G3101",
        "G3102",
        "G3103",
        "G3104",
        "G3105",
        "G3106",
        "G3107",
        "G3108",
        "G3109",
        "G3110",
        "G3111",
        "G3112",
        "G3113",
        "G3114",
        "G3115",
        "G3116",
        "G3117",
        "G3118",
        "G3119",
        "G3120",
        "G3121",
        "G3122",
        "G3123",
        "G3124",
        "G3125",
        "G3126",
        "G3127",
        "G3128",
        "G3129",
        "G3130",
        "G3131",
        "G3132",
        "G3133",
        "G3134",
        "G3135",
        "G3136",
        "G3137",
        "G3138",
        "G3139",
        "G3140",
        "G3141",
        "G3142",
        "G3143",
        "G3144",
        "G3145",
        "G3146",
        "G3147",
        "G3148",
        "G3149",
        "G3150",
        "G3151",
        "G3152",
        "G3153",
        "G3154",
        "G3155",
        "G3156",
        "G3157",
        "G3158",
        "G3159",
        "G3160",
        "G3161",
        "G3162",
        "G3163",
        "G3164",
        "G3165",
        "G3166",
        "G3167",
        "G3168",
        "G3169",
        "G3170",
        "G3171",
        "G3172",
        "G3173",
        "G3174",
        "G3175",
        "G3176",
        "G3177",
        "G3178",
        "G3179",
        "G3180",
        "G3181",
        "G3182",
        "G3183",
        "G3184",
        "G3185",
        "G3186",
        "G3187",
        "G3188",
        "G3189",
        "G3190",
        "G3191",
        "G3192",
        "G3193",
        "G3194",
        "G3195",
        "G3196",
        "G3197",
        "G3198",
        "G3199",
        "G3200",
        "G50"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165,
            "rb": 60,
            "vo": 180,
            "kas": 300,
            "dh": 105,
            "kes": 360,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "1e Pet - Vlaardingen - Zevenmanshav."
      ],
      "berths": [
        "G51",
        "G52",
        "G709",
        "G710",
        "G711",
        "G712",
        "G713",
        "G714",
        "G715",
        "G716",
        "G717",
        "G718",
        "G719",
        "G720",
        "G721",
        "G722",
        "G723",
        "G724",
        "G725",
        "G726",
        "G727",
        "G728",
        "G729",
        "G730",
        "G731",
        "G732",
        "G733",
        "G734",
        "G735",
        "G736",
        "G737",
        "G738",
        "G739",
        "G740",
        "G741",
        "G742",
        "G743",
        "G744",
        "G745",
        "G746",
        "G747",
        "G748",
        "G749",
        "G750",
        "G751",
        "G752",
        "G753",
        "G754",
        "G755",
        "G756",
        "G757",
        "G758",
        "G759",
        "G760",
        "G3201",
        "G3202",
        "G3203",
        "G3204",
        "G3205",
        "G3206",
        "G3207",
        "G3208",
        "G3209",
        "G3210",
        "G3211",
        "G3212",
        "G3213",
        "G3214",
        "G3215",
        "G3216",
        "G3217",
        "G3218",
        "G3219",
        "G3220",
        "G3221",
        "G3222",
        "G3223",
        "G3224",
        "G3225",
        "G3226",
        "G3227",
        "G3228",
        "G3229",
        "G3230",
        "G3231",
        "G3232",
        "G3233",
        "G3234",
        "G3235",
        "G3236",
        "G3237",
        "G3238",
        "G3239",
        "G3240",
        "G3241",
        "G3242",
        "G3243",
        "G3244",
        "G3245",
        "G3246",
        "G3247",
        "G3248",
        "G3249",
        "G3250",
        "G3251",
        "G3252",
        "G3253",
        "G3254",
        "G3255",
        "G3256",
        "G3257",
        "G3258",
        "G3259",
        "G3260",
        "G3261",
        "G3262",
        "G3263",
        "G3264",
        "G3265",
        "G3266",
        "G3267",
        "G3268",
        "G3269",
        "G3270",
        "G3271",
        "G3272",
        "G3273",
        "G3274",
        "G3275",
        "G3276",
        "G3277",
        "G3278",
        "G3279",
        "G3280",
        "G3281",
        "G3282",
        "G3283",
        "G3284",
        "G3285",
        "G3286",
        "G3287",
        "G3288",
        "G3289",
        "G3290",
        "G3291",
        "G3292",
        "G3293",
        "G3294",
        "G3295",
        "G3296",
        "G3297",
        "G3298",
        "G3299",
        "G3300",
        "G3301",
        "G3302",
        "G3303",
        "G3304",
        "G3305",
        "G3306",
        "G3307",
        "G3308",
        "G3309",
        "G3310",
        "G3311",
        "G3312",
        "G3313",
        "G3314",
        "G3315",
        "G3316",
        "G3317",
        "G3318",
        "G3319",
        "G3320",
        "G3321",
        "G3322",
        "G3323",
        "G3324",
        "G3325",
        "G3326",
        "G3327",
        "G3328",
        "G3329",
        "G3330",
        "G3331",
        "G3332",
        "G3333",
        "G3334",
        "G3335",
        "G3336",
        "G3337",
        "G3338",
        "G3339",
        "G3340",
        "G3341",
        "G3342",
        "G3343",
        "G3344",
        "G3345",
        "G3346",
        "G3347",
        "G3348",
        "G3349",
        "G3350",
        "G3351",
        "G3352",
        "G3353",
        "G3354",
        "G3355",
        "G3356",
        "G3357",
        "G3358",
        "G3359",
        "G3360",
        "G3361",
        "G3362",
        "G3363",
        "G3364",
        "G3365",
        "G3366",
        "G3367",
        "G3368",
        "G3369",
        "G3370",
        "G3371",
        "G3372",
        "G3373",
        "G3374",
        "G3375",
        "G3376",
        "G3377",
        "G3378",
        "G3379",
        "G3380",
        "G3381",
        "G3382",
        "G3383",
        "G3384",
        "G3385",
        "G3386",
        "G3387",
        "G3388",
        "G3389",
        "G3390",
        "G3391",
        "G3392",
        "G3393",
        "G3394",
        "G3395",
        "G3396",
        "G3397",
        "G3398",
        "G3399",
        "G3400",
        "G3401",
        "G3402",
        "G3403",
        "G3404",
        "G3405",
        "G3406",
        "G3407",
        "G3408",
        "G3409",
        "G3410",
        "G3411",
        "G3412",
        "G3413",
        "G3414",
        "G3415",
        "G3416",
        "G3417",
        "G3418",
        "G3419",
        "G3420",
        "G3421",
        "G3422",
        "G3423",
        "G3424",
        "G3425",
        "G3426",
        "G3427",
        "G3428",
        "G3429",
        "G3430",
        "G3431",
        "G3432",
        "G3433",
        "G3434",
        "G3435",
        "G3436",
        "G3437",
        "G3438",
        "G3439",
        "G3440",
        "G3441",
        "G3442",
        "G3443",
        "G3444",
        "G3445",
        "G3446",
        "G3447",
        "G3448",
        "G3449",
        "G3450",
        "G3451",
        "G3452",
        "G3453",
        "G3454",
        "G3455",
        "G3456",
        "G3457",
        "G3458",
        "G3459",
        "G3460",
        "G3461",
        "G3462",
        "G3463",
        "G3464",
        "G3465",
        "G3466",
        "G3467",
        "G3468",
        "G3469",
        "G3470",
        "G3471",
        "G3472",
        "G3473",
        "G3474",
        "G3475",
        "G3476",
        "G3477",
        "G3478",
        "G3479",
        "G3480",
        "G3481",
        "G3482",
        "G3483",
        "G3484",
        "G3485",
        "G3486",
        "G3487",
        "G3488",
        "G3489",
        "G3490",
        "G3491",
        "G3492",
        "G3493",
        "G3494",
        "G3495",
        "G3496",
        "G3497",
        "G3498",
        "G3499",
        "G3500",
        "G3501",
        "G3502",
        "G3503",
        "G3504",
        "G3505",
        "G3506",
        "G3507",
        "G3508",
        "G3509",
        "G3510",
        "G3511",
        "G3512",
        "G3513",
        "G3514",
        "G3515",
        "G3516",
        "G3517",
        "G3518",
        "G3519",
        "G3520",
        "G3521",
        "G3522",
        "G3523",
        "G3524",
        "G3525",
        "G3526",
        "G3527",
        "G3528",
        "G3529",
        "G3530",
        "G3531",
        "G3532",
        "G3533",
        "G3534",
        "G3535",
        "G3536",
        "G3537",
        "G3538",
        "G3539",
        "G3540",
        "G3541",
        "G3542",
        "G3543",
        "G3544",
        "G3545",
        "G3546",
        "G3547",
        "G3548",
        "G3549",
        "G3550",
        "G3551",
        "G3552",
        "G3553",
        "G3554",
        "G3555",
        "G3556",
        "G3557",
        "G3558",
        "G3559",
        "G3560",
        "G3561",
        "G3562",
        "G3563",
        "G3564",
        "G3565",
        "G3566",
        "G3567",
        "G3568",
        "G3569",
        "G3570",
        "G3571",
        "G3572",
        "G3573",
        "G3574",
        "G3575",
        "G3576",
        "G3577",
        "G3578",
        "G3579",
        "G3580",
        "G3581",
        "G3582",
        "G3583",
        "G3584",
        "G3585",
        "G3586",
        "G3587",
        "G3588",
        "G3589",
        "G3590",
        "G3591",
        "G3592",
        "G3593",
        "G3594",
        "G3595",
        "G3596",
        "G3597",
        "G3598",
        "G3599",
        "G3600",
        "G3601",
        "G3602",
        "G3603",
        "G3604",
        "G3605",
        "G3606",
        "G3607",
        "G3608",
        "G3609",
        "G3610",
        "G3611",
        "G3612",
        "G3613",
        "G3614",
        "G3615",
        "G3616",
        "G3617",
        "G3618",
        "G3619",
        "G3620",
        "G3621",
        "G3622",
        "G3623",
        "G3624",
        "G3625",
        "G3626",
        "G3627",
        "G3628",
        "G3629",
        "G3630",
        "G3631",
        "G3632",
        "G3633",
        "G3634",
        "G3635",
        "G3636",
        "G3637",
        "G3638",
        "G3639",
        "G3640",
        "G3641",
        "G3642",
        "G3643",
        "G3644",
        "G3645",
        "G3646",
        "G3647",
        "G3648",
        "G3649",
        "G3650",
        "G3651",
        "G3652",
        "G3653",
        "G3654",
        "G3655",
        "G3656",
        "G3657",
        "G3658",
        "G3659",
        "G3660",
        "G3661",
        "G3662",
        "G3663",
        "G3664",
        "G3665",
        "G3666",
        "G3667",
        "G3668",
        "G3669",
        "G3670",
        "G3671",
        "G3672",
        "G3673",
        "G3674",
        "G3675",
        "G3676",
        "G3677",
        "G3678",
        "G3679",
        "G3680",
        "G3681",
        "G3682",
        "G3683",
        "G3684",
        "G3685",
        "G3686",
        "G3687",
        "G3688",
        "G3689",
        "G3690",
        "G3691",
        "G3692",
        "G3693",
        "G3694",
        "G3695",
        "G3696",
        "G3697",
        "G3698",
        "G3699",
        "G3700",
        "G3701",
        "G3702",
        "G3703",
        "G3704",
        "G3705",
        "G3706",
        "G3707",
        "G3708",
        "G3709",
        "G3710",
        "G3711",
        "G3712",
        "G3713",
        "G3714",
        "G3715",
        "G3716",
        "G3717",
        "G3718",
        "G3719",
        "G3720",
        "G3721",
        "G3722",
        "G3723",
        "G3724",
        "G3725",
        "G3726",
        "G3727",
        "G3728",
        "G3729",
        "G3730",
        "G3731",
        "G3732",
        "G3733",
        "G3734",
        "G3735",
        "G3736",
        "G3737",
        "G3738",
        "G3739",
        "G3740",
        "G3741",
        "G3742",
        "G3743",
        "G3744",
        "G3745",
        "G3746",
        "G3747",
        "G3748",
        "G3749",
        "G3750",
        "G3751",
        "G3752",
        "G3753",
        "G3754",
        "G3755",
        "G3756",
        "G3757",
        "G3758",
        "G3759",
        "G3760",
        "G3761",
        "G3762",
        "G3763",
        "G3764",
        "G3765",
        "G3766",
        "G3767",
        "G3768",
        "G3769",
        "G3770",
        "G3771",
        "G3772",
        "G3773",
        "G3774",
        "G3775",
        "G3776",
        "G3777",
        "G3778",
        "G3779",
        "G3780",
        "G3781",
        "G3782",
        "G3783",
        "G3784",
        "G3785",
        "G3786",
        "G3787",
        "G3788",
        "G3789",
        "G3790",
        "G3791",
        "G3792",
        "G3793",
        "G3794",
        "G3795",
        "G3796",
        "G3797",
        "G3798",
        "G3799",
        "G3800",
        "G3801",
        "G3802",
        "G3803",
        "G3804",
        "G3805",
        "G3806",
        "G3807",
        "G3808",
        "G3809",
        "G3810",
        "G3811",
        "G3812",
        "G3813",
        "G3814",
        "G3815",
        "G3816",
        "G3817",
        "G3818",
        "G3819",
        "G3820",
        "G3821",
        "G3822",
        "G3823",
        "G3824",
        "G3825",
        "G3826",
        "G3827",
        "G3828",
        "G3829",
        "G3830",
        "G3831",
        "G3832",
        "G3833",
        "G3834",
        "G3835",
        "G3836",
        "G3837",
        "G3838",
        "G3839",
        "G3840",
        "G3841",
        "G3842",
        "G3843",
        "G3844",
        "G3845",
        "G3846",
        "G3847",
        "G3848",
        "G3849",
        "G3850",
        "G3851",
        "G3852",
        "G3853",
        "G3854",
        "G3855",
        "G3856",
        "G3857",
        "G3858",
        "G3859",
        "G3860",
        "G3861",
        "G3862",
        "G3863",
        "G3864",
        "G3865",
        "G3866",
        "G3867",
        "G3868",
        "G3869",
        "G3870",
        "G3871",
        "G3872",
        "G3873",
        "G3874",
        "G3875",
        "G3876",
        "G3877",
        "G3878",
        "G3879",
        "G3880",
        "G3881",
        "G3882",
        "G3883",
        "G3884",
        "G3885",
        "G3886",
        "G3887",
        "G3888",
        "G3889",
        "G3890",
        "G3891",
        "G3892",
        "G3893",
        "G3894",
        "G3895",
        "G3896",
        "G3897",
        "G3898",
        "G3899",
        "G3900",
        "G3901",
        "G3902",
        "G3903",
        "G3904",
        "G3905",
        "G3906",
        "G3907",
        "G3908",
        "G3909",
        "G3910",
        "G3911",
        "G3912",
        "G3913",
        "G3914",
        "G3915",
        "G3916",
        "G3917",
        "G3918",
        "G3919",
        "G3920",
        "G3921",
        "G3922",
        "G3923",
        "G3924",
        "G3925",
        "G3926",
        "G3927",
        "G3928",
        "G3929",
        "G3930",
        "G3931",
        "G3932",
        "G3933",
        "G3934",
        "G3935",
        "G3936",
        "G3937",
        "G3938",
        "G3939",
        "G3940",
        "G3941",
        "G3942",
        "G3943",
        "G3944",
        "G3945",
        "G3946",
        "G3947",
        "G3948",
        "G3949",
        "G3950",
        "G3951",
        "G3952",
        "G3953",
        "G3954",
        "G3955",
        "G3956",
        "G3957",
        "G3958",
        "G3959",
        "G3960",
        "G3961",
        "G3962",
        "G3963",
        "G3964",
        "G3965",
        "G3966",
        "G3967",
        "G3968",
        "G3969",
        "G3970",
        "G3971",
        "G3972",
        "G3973",
        "G3974",
        "G3975",
        "G3976",
        "G3977",
        "G3978",
        "G3979",
        "G3980",
        "G3981",
        "G3982",
        "G3983",
        "G3984",
        "G3985",
        "G3986",
        "G3987",
        "G3988",
        "G3989",
        "G3990",
        "G3991",
        "G3992",
        "G3993",
        "G3994",
        "G3995",
        "G3996",
        "G3997",
        "G3998",
        "G3999",
        "G4000",
        "G4001",
        "G4002",
        "G4003",
        "G4004",
        "G4005",
        "G4006",
        "G4007",
        "G4008",
        "G4009",
        "G4010",
        "G4011",
        "G4012",
        "G4013",
        "G4014",
        "G4015",
        "G4016",
        "G4017",
        "G4018",
        "O4321",
        "O4326",
        "O4327"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150,
            "rb": 75,
            "vo": 165,
            "kas": 285,
            "dh": 105,
            "kes": 345,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Botlek - 3e Pet"
      ],
      "berths": [
        "G61",
        "G62",
        "G63",
        "G64",
        "G65",
        "G66",
        "G4019",
        "G4020",
        "G4021",
        "G4022",
        "G4023",
        "G4024",
        "G4025",
        "G4026",
        "G4027",
        "G4028",
        "G4029",
        "G4030",
        "G4031",
        "G4032",
        "G4033",
        "G4034",
        "G4035",
        "G4036",
        "G4037",
        "G4038",
        "G4039",
        "G4040",
        "G4041",
        "G4042",
        "G4043",
        "G4044",
        "G4045",
        "G4046",
        "G4047",
        "G4048",
        "G4049",
        "G4050",
        "G4051",
        "G4052",
        "G4053",
        "G4054",
        "G4055",
        "G4056",
        "G4057",
        "G4058",
        "G4059",
        "G4060",
        "G4061",
        "G4062",
        "G4063",
        "G4064",
        "G4065",
        "G4066",
        "G4067",
        "G4068",
        "G4069",
        "G4070",
        "G4071",
        "G4072",
        "G4073",
        "G4074",
        "G4075",
        "G4076",
        "G4077",
        "G4078",
        "G4079",
        "G4080",
        "G4081",
        "G4082",
        "G4083",
        "G4084",
        "G4085",
        "G4086",
        "G4087",
        "G4088",
        "G4089",
        "G4090",
        "G4091",
        "G4092",
        "G4093",
        "G4094",
        "G4095",
        "G4096",
        "G4097",
        "G4098",
        "G4099",
        "G4100",
        "G4101",
        "G4102",
        "G4103",
        "G4104",
        "G4105",
        "G4106",
        "G4107",
        "G4108",
        "G4109",
        "G4110",
        "G4111",
        "G4112",
        "G4113",
        "G4114",
        "G4115",
        "G4116",
        "G4117",
        "G4118",
        "G4119",
        "G4120",
        "G4121",
        "G4122",
        "G4123",
        "G4124",
        "G4125",
        "G4126",
        "G4127",
        "G4128",
        "G4129",
        "G4130",
        "G4131",
        "G4132",
        "G4133",
        "G4134",
        "G4135",
        "G4136",
        "G4137",
        "G4138",
        "G4139",
        "G4140",
        "G4141",
        "G4142",
        "G4143",
        "G4144",
        "G4145",
        "G4146",
        "G4147",
        "G4148",
        "G4149",
        "G4150",
        "G4151",
        "G4152",
        "G4153",
        "G4154",
        "G4155",
        "G4156",
        "G4157",
        "G4158",
        "G4159",
        "G4160",
        "G4161",
        "G4162",
        "G4163",
        "G4164",
        "G4165",
        "G4166",
        "G4167",
        "G4168",
        "G4169",
        "G4170",
        "G4171",
        "G4172",
        "G4173",
        "G4174",
        "G4175",
        "G4176",
        "G4177",
        "G4178",
        "G4179",
        "G4180",
        "G4181",
        "G4182",
        "G4183",
        "G4184",
        "G4185",
        "G4186",
        "G4187",
        "G4188",
        "G4189",
        "G4190",
        "G4191",
        "G4192",
        "G4193",
        "G4194",
        "G4195",
        "G4196",
        "G4197",
        "G4198",
        "G4199",
        "G4200",
        "G4201",
        "G4202",
        "G4203",
        "G4204",
        "G4205",
        "G4206",
        "G4207",
        "G4208",
        "G4209",
        "G4210",
        "G4211",
        "G4212",
        "G4213",
        "G4214",
        "G4215",
        "G4216",
        "G4217",
        "G4218",
        "G4219",
        "G4220",
        "G4221",
        "G4222",
        "G4223",
        "G4224",
        "G4225",
        "G4226",
        "G4227",
        "G4228",
        "G4229",
        "G4230",
        "G4231",
        "G4232",
        "G4233",
        "G4234",
        "G4235",
        "G4236",
        "G4237",
        "G4238",
        "G4239",
        "G4240",
        "G4241",
        "G4242",
        "G4243",
        "G4244",
        "G4245",
        "G4246",
        "G4247",
        "G4248",
        "G4249",
        "G4250",
        "G4251",
        "G4252",
        "G4253",
        "G4254",
        "G4255",
        "G4256",
        "G4257",
        "G4258",
        "G4259",
        "G4260",
        "G4261",
        "G4262",
        "G4263",
        "G4264",
        "G4265",
        "G4266",
        "G4267",
        "G4268",
        "G4269",
        "G4270",
        "G4271",
        "G4272",
        "G4273",
        "G4274",
        "G4275",
        "G4276",
        "G4277",
        "G4278",
        "G4279",
        "G4280",
        "G4281",
        "G4282",
        "G4283",
        "G4284",
        "G4285",
        "G4286",
        "G4287",
        "G4288",
        "G4289",
        "G4290",
        "G4291",
        "G4292",
        "G4293",
        "G4294",
        "G4295",
        "G4296",
        "G4297",
        "G4298",
        "G4299",
        "G4300",
        "G4301",
        "G4302",
        "G4303",
        "G4304",
        "G4305",
        "G4306",
        "G4307",
        "G4308",
        "G4309",
        "G4310",
        "G4311",
        "G4312",
        "G4313",
        "G4314",
        "G4315",
        "G4316",
        "G4317",
        "G4318",
        "G4319",
        "G4320",
        "G4321",
        "G4322",
        "G4323",
        "G4324",
        "G4325",
        "G4326",
        "G4327",
        "G4328",
        "G4329",
        "G4330",
        "G4331",
        "G4332",
        "G4333",
        "G4334",
        "G4335",
        "G4336",
        "G4337",
        "G4338",
        "G4339",
        "G4340",
        "G4341",
        "G4342",
        "G4343",
        "G4344",
        "G4345",
        "G4346",
        "G4347",
        "G4348",
        "G4349",
        "G4350",
        "G4351",
        "G4352",
        "G4353",
        "G4354",
        "G4355",
        "G4356",
        "G4357",
        "G4358",
        "G4359",
        "G4360",
        "G4361",
        "G4362",
        "G4363",
        "G4364",
        "G4365",
        "G4366",
        "G4367",
        "G4368",
        "G4369",
        "G4370",
        "G4371",
        "G4372",
        "G4373",
        "G4374",
        "G4375",
        "G4376",
        "G4377",
        "G4378",
        "G4379",
        "G4380",
        "G4381",
        "G4382",
        "G4383",
        "G4384",
        "G4385",
        "G4386",
        "G4387",
        "G4388",
        "G4389",
        "G4390",
        "G4391",
        "G4392",
        "G4393",
        "G4394",
        "G4395",
        "G4396",
        "G4397",
        "G4398",
        "G4399",
        "G4400",
        "G4401",
        "G4402",
        "G4403",
        "G4404",
        "G4405",
        "G4406",
        "G4407",
        "G4408",
        "G4409",
        "G4410",
        "G4411",
        "G4412",
        "G4413",
        "G4414",
        "G4415",
        "G4416",
        "G4417",
        "G4418",
        "G4419",
        "G4420",
        "G4421",
        "G4422",
        "G4423",
        "G4424",
        "G4425",
        "G4426",
        "G4427",
        "G4428",
        "G4429",
        "G4430",
        "G4431",
        "G4432",
        "G4433",
        "G4434",
        "G4435",
        "G4436",
        "G4437",
        "G4438",
        "G4439",
        "G4440",
        "G4441",
        "G4442",
        "G4443",
        "G4444",
        "G4445",
        "G4446",
        "G4447",
        "G4448",
        "G4449",
        "G4450",
        "G4451",
        "G4452",
        "G4453",
        "G4454",
        "G4455",
        "G4456",
        "G4457",
        "G4458",
        "G4459",
        "G4460",
        "G4461",
        "G4462",
        "G4463",
        "G4464",
        "G4465",
        "G4466",
        "G4467",
        "G4468",
        "G4469",
        "G4470",
        "G4471",
        "G4472",
        "G4473",
        "G4474",
        "G4475",
        "G4476",
        "G4477",
        "G4478",
        "G4479",
        "G4480",
        "G4481",
        "G4482",
        "G4483",
        "G4484",
        "G4485",
        "G4486",
        "G4487",
        "G4488",
        "G4489",
        "G4490",
        "G4491",
        "G4492",
        "G4493",
        "G4494",
        "G4495",
        "G4496",
        "G4497",
        "G4498",
        "G4499",
        "G4500",
        "G4501",
        "G4502",
        "G4503",
        "G4504",
        "G4505",
        "G4506",
        "G4507",
        "G4508",
        "G4509",
        "G4510",
        "G4511",
        "G4512",
        "G4513",
        "G4514",
        "G4515",
        "G4516",
        "G4517",
        "G4518",
        "G4519",
        "G4520",
        "G4521",
        "G4522",
        "G4523",
        "G4524",
        "G4525",
        "G4526",
        "G4527",
        "G4528",
        "G4529",
        "G4530",
        "G4531",
        "G4532",
        "G4533",
        "G4534",
        "G4535",
        "G4536",
        "G4537",
        "G4538",
        "G4539",
        "G4540",
        "G4541",
        "G4542",
        "G4543",
        "G4544",
        "G4545",
        "G4546",
        "G4547",
        "G4548",
        "G4549",
        "G4550",
        "G4551",
        "G4552",
        "G4553",
        "G4554",
        "G4555",
        "G4556",
        "G4557",
        "G4558",
        "G4559",
        "G4560",
        "G4561",
        "G4562",
        "G4563",
        "G4564",
        "G4565",
        "G4566",
        "G4567",
        "G4568",
        "G4569",
        "G4570",
        "G4571",
        "G4572",
        "G4573",
        "G4574",
        "G4575",
        "G4576",
        "G4577",
        "G4578",
        "G4579",
        "O910",
        "O4495",
        "O4496",
        "O4498",
        "O4499",
        "O9721",
        "O9722"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150,
            "rb": 90,
            "vo": 165,
            "kas": 285,
            "dh": 105,
            "kes": 345,
            "vs": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 405,
            "lng": 255,
            "e13": 225,
            "mc": 210
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 420,
            "lng": 270,
            "e13": 240,
            "mc": 225
          }
        }
      ]
    },
    {
      "descriptions": [
        "Rozenburg"
      ],
      "berths": [
        "O2840"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105
          }
        }
      ]
    },
    {
      "descriptions": [
        "Scheurkade"
      ],
      "berths": [
        "G783",
        "G778",
        "G781",
        "G780",
        "G4580",
        "G4581",
        "G4582",
        "G4583",
        "G4584",
        "G4585",
        "G4586",
        "G4587",
        "G4588",
        "G4589",
        "G4590",
        "G4591",
        "G4592",
        "G4593",
        "G4594",
        "G4595"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135,
            "rb": 90,
            "vo": 165,
            "kas": 285,
            "dh": 105,
            "kes": 345,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Maassluis"
      ],
      "berths": [
        "G802"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 90,
            "vo": 195,
            "kas": 315,
            "dh": 105,
            "kes": 375,
            "vs": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Hoek van Holland"
      ],
      "berths": [
        "G906",
        "G907",
        "G908",
        "G909",
        "G910",
        "G911",
        "G912",
        "G913",
        "G914",
        "G915",
        "G916",
        "G917",
        "G918",
        "G919",
        "G920",
        "G921",
        "G922",
        "G923",
        "G924"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 270,
            "lng": 120,
            "e13": 90,
            "mc": 75,
            "rb": 120,
            "vo": 240,
            "kas": 360,
            "dh": 150,
            "kes": 360,
            "vs": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Seinehaven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G5103",
        "G5104",
        "G5105",
        "G5107",
        "G5108",
        "G5109",
        "G5113"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 405,
            "lng": 255,
            "e13": 225,
            "mc": 210,
            "rb": 120,
            "vo": 225,
            "kas": 345,
            "dh": 135,
            "kes": 405,
            "vs": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "Britanni�haven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G5201",
        "G5202",
        "G5203",
        "G5204",
        "G5205",
        "G5206",
        "G5207",
        "G5208",
        "G5209",
        "G5210",
        "G5211",
        "G5212",
        "G5213",
        "G5214",
        "G5215",
        "G5216",
        "G5217",
        "G5218",
        "G5219",
        "G5220",
        "G5221",
        "G5222",
        "G5223",
        "G5224",
        "G5225",
        "G5226",
        "G5227",
        "G5228",
        "G5229",
        "G5230",
        "G5231",
        "G5232",
        "G5233",
        "G5234",
        "G5235",
        "G5236",
        "G5237",
        "G5238"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135,
            "rb": 150,
            "vo": 210,
            "kas": 330,
            "dh": 150,
            "kes": 390,
            "vs": 165
          }
        }
      ]
    },
    {
      "descriptions": [
        "7e Pet"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G72",
        "G73",
        "G74",
        "G75",
        "G76",
        "G84",
        "G5320",
        "G5321",
        "G5322",
        "G5323",
        "G5324",
        "G5325",
        "G5326",
        "G5327",
        "G5328",
        "G5329",
        "G5330",
        "G5331",
        "G5332",
        "G5333",
        "G5334",
        "G5335",
        "G5336",
        "G5337",
        "G5508",
        "G5509",
        "G5510",
        "G5511",
        "G5512",
        "G5513",
        "G5514",
        "G5515",
        "G5516",
        "G5517",
        "G5518",
        "G5519",
        "G5520",
        "G5521",
        "G5522",
        "G5523",
        "G5524",
        "G5525",
        "G5526",
        "G5527",
        "G5528",
        "G5529",
        "G5530",
        "G5531",
        "G5532",
        "G5533",
        "G5534",
        "G5535",
        "G5536",
        "G5537",
        "G5538",
        "G5539",
        "G5540",
        "G5541",
        "G5542",
        "G5543",
        "G5544",
        "G5545",
        "G5546",
        "G5547",
        "G5548",
        "G5549",
        "G5550",
        "G5551",
        "G5552",
        "G5553",
        "G5554",
        "G5555",
        "G5556",
        "G5557",
        "G5558",
        "G5559",
        "G5560",
        "G5561",
        "G5562",
        "G5563",
        "G5564",
        "G5565",
        "G5566",
        "G5567",
        "G5568",
        "G5569",
        "G5570",
        "G5571",
        "G5572",
        "G5573",
        "G5574",
        "G5575",
        "G5576",
        "G5577",
        "G5578",
        "G5579",
        "G5580",
        "G5581",
        "G5582",
        "G5583",
        "G5584",
        "G5585",
        "G5586",
        "G5587",
        "G5588",
        "G5589",
        "G5590",
        "G5591",
        "G5592",
        "G5593",
        "G5594",
        "G5595",
        "G5596",
        "G5597",
        "G5598",
        "G5599",
        "G5600",
        "G5601",
        "G5602",
        "G5603",
        "G5604",
        "G5605",
        "G5606",
        "G5607",
        "G5608",
        "G5609",
        "G5610",
        "G5611",
        "G5612",
        "G5613",
        "G5614",
        "G5615",
        "O4441",
        "O4355",
        "O9880"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<15000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 165,
            "vo": 225,
            "kas": 345,
            "dh": 180,
            "kes": 405,
            "vs": 195
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=15000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "draughtInCm": ">1430"
          },
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165
          }
        }
      ]
    },
    {
      "descriptions": [
        "Caldic-ETT-Palen/boeien CK"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G77",
        "G78",
        "G79",
        "G80",
        "G81",
        "G82",
        "G83",
        "G5338",
        "G5339",
        "G5340",
        "G5341",
        "G5342",
        "G5343",
        "G5344",
        "G5345",
        "G5346",
        "G5347",
        "G5348",
        "G5349",
        "G5350",
        "G5351",
        "G5352",
        "G5353",
        "G5354",
        "G5355",
        "G5356",
        "G5357",
        "G5358",
        "G5359",
        "G5360",
        "G5361",
        "G5616",
        "G5617",
        "G5618",
        "G5619",
        "G5620",
        "G5621",
        "G5622",
        "G5623",
        "G5624",
        "G5625",
        "G5626",
        "G5627",
        "G5628",
        "G5629",
        "G5630",
        "G5631",
        "G5632",
        "G5633",
        "G5634",
        "G5635",
        "G5636",
        "G5637",
        "G5638",
        "G5639",
        "G5640",
        "O979",
        "O9791",
        "O9794",
        "O9795",
        "O9896"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<15000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 150,
            "vo": 255,
            "kas": 375,
            "dh": 180,
            "kes": 435,
            "vs": 195
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=15000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "draughtInCm": ">1430"
          },
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165
          }
        }
      ]
    },
    {
      "descriptions": [
        "5e Pet"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G5362",
        "G5363",
        "G5364",
        "G5365",
        "G5366",
        "G5367",
        "G5368",
        "G5369",
        "G5370",
        "G5371",
        "G5372",
        "G5373",
        "G5374",
        "G5375",
        "G5376",
        "G5377",
        "G5378",
        "G5379",
        "G5380",
        "G5641",
        "G5642",
        "G5643",
        "G5644",
        "G5645",
        "G5646",
        "G5647",
        "G5648",
        "G5649",
        "G5650",
        "G5651",
        "G5652",
        "G5653",
        "G5654",
        "G5655",
        "G5656",
        "G5657",
        "G5658",
        "G5659",
        "G5660",
        "G5661",
        "G5662",
        "G5663",
        "G5664",
        "G5665",
        "G5666",
        "G5667",
        "G5668",
        "G5669",
        "G5670",
        "G5671",
        "G5672",
        "G5673",
        "G5674",
        "G5675",
        "G5676",
        "G5677",
        "G5678",
        "G5679",
        "G5680",
        "G5681",
        "G5682",
        "G5683",
        "G5684",
        "G5685",
        "G5686",
        "G5687",
        "G5688",
        "G5689",
        "G5690",
        "G5691",
        "G5692",
        "G5693",
        "G5694",
        "G5695",
        "G5696",
        "G5697",
        "G5698",
        "G5699",
        "G5700",
        "G5701",
        "G5702",
        "G5703",
        "G5704",
        "G5705",
        "G5706",
        "G5707",
        "G5708",
        "G5709",
        "G5710",
        "G5711",
        "G5712",
        "G5713",
        "G5714",
        "G5715"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 150,
            "vo": 255,
            "kas": 375,
            "dh": 165,
            "kes": 435,
            "vs": 180
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165
          }
        }
      ]
    },
    {
      "descriptions": [
        "4e Pet"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G5381",
        "G5382",
        "G5383",
        "G5384",
        "G5385",
        "G5386",
        "G5387",
        "G5388",
        "G5389",
        "G5390",
        "G5391",
        "G5392",
        "G5393",
        "G5394",
        "G5395",
        "G5396",
        "G5397",
        "G5398",
        "G5399",
        "G5400",
        "G5401",
        "G5402",
        "G5403",
        "G5404",
        "G5405",
        "G5716",
        "G5717",
        "G5718",
        "G5719",
        "G5720",
        "G5721",
        "G5722",
        "G5723",
        "G5724",
        "G5725",
        "G5726",
        "G5727",
        "G5728",
        "G5729",
        "G5730",
        "G5731",
        "G5732",
        "G5733",
        "G5734",
        "G5735",
        "G5736",
        "G5737",
        "O4463"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 150,
            "kes": 420,
            "vs": 165
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Beneluxhaven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G5738",
        "G5739",
        "G5740",
        "G5741",
        "G5742",
        "G5743",
        "G5744",
        "G5745",
        "G5746",
        "G5747",
        "G5748",
        "G5749",
        "G5750",
        "G5751",
        "G5752",
        "G5753",
        "G5754",
        "G5755",
        "G5756",
        "G5757",
        "G5758",
        "G5759",
        "G5760",
        "G5761",
        "G5762",
        "G5763",
        "G5764",
        "G5765",
        "G5766",
        "G5767",
        "G5768",
        "G5769",
        "G5770",
        "G5771",
        "G5772",
        "G5773",
        "G5774",
        "G5775",
        "G5776",
        "G5777",
        "G5778",
        "G5779",
        "G5780",
        "G5781",
        "G5782",
        "G5783",
        "G5784",
        "G5785",
        "G5786",
        "G5787",
        "G5788",
        "G5789",
        "G5790",
        "G5791",
        "G5792",
        "G5793",
        "G5794",
        "G5795",
        "G5796",
        "G5797",
        "G5798",
        "G5799",
        "G5800",
        "G5801",
        "G5802",
        "G5803",
        "G5804",
        "G5805",
        "G5806",
        "G5807",
        "G5808",
        "G5809",
        "G5810",
        "G5811",
        "G5812",
        "G5813",
        "G5814",
        "G5815",
        "G5816",
        "G5817",
        "G5818",
        "G5819",
        "G5820",
        "G5821",
        "G5822",
        "G5823",
        "G5824",
        "G5825",
        "G5826",
        "G5827",
        "G5828",
        "G5829",
        "G5830",
        "G5831",
        "G5832",
        "G5833",
        "G5834",
        "G5835",
        "G5836",
        "G5837",
        "G5838",
        "G5839",
        "G5840",
        "G5841",
        "G5842",
        "G5843",
        "G5844",
        "G5845",
        "G5846",
        "G5847",
        "G5848",
        "G5849",
        "G5850",
        "G5851",
        "G5852",
        "G5853",
        "G5854",
        "G5855",
        "G5856",
        "G5857",
        "G5858",
        "G5859",
        "G5860",
        "G5861",
        "G5862",
        "G5863",
        "G5864",
        "G5865",
        "G5866",
        "G5867",
        "G5868",
        "G5869",
        "G5870",
        "G5871",
        "G5872",
        "G5873",
        "G5874",
        "G5875",
        "G5876",
        "G5877",
        "G5878",
        "G5879",
        "G5880",
        "G5881",
        "G5882",
        "G5883",
        "G5884",
        "G5885",
        "G5886",
        "G5887",
        "G5888",
        "G5889",
        "G5890",
        "G5891",
        "G5892",
        "G5893",
        "G5894",
        "G5895",
        "G5896",
        "G5897",
        "G5898",
        "G5899",
        "G5900",
        "G5901",
        "G5902",
        "G5903",
        "G5904",
        "G5905",
        "G5906",
        "G5907",
        "G5908",
        "G5909",
        "G5910",
        "G5911",
        "G5912",
        "G5913",
        "G5914",
        "G5915",
        "G5916",
        "G5917",
        "G5918",
        "G5919",
        "G5920",
        "G5921",
        "G5922",
        "G5923",
        "G5924",
        "G5925",
        "G5926",
        "G5927",
        "G5928",
        "G5929",
        "G5930",
        "G5931",
        "G5932",
        "G5933",
        "G5934",
        "G5935",
        "G5936",
        "G5937",
        "G5938",
        "G5939",
        "G5940",
        "G5941",
        "G5942",
        "G5943",
        "G5944",
        "G5945",
        "G5946",
        "G5947",
        "G5948",
        "G5949",
        "G5950",
        "G5951",
        "G5952",
        "G5953",
        "G5954",
        "G5955",
        "G5956",
        "G5957",
        "G5958",
        "G5959",
        "G5960",
        "G5961",
        "G5962",
        "G5963",
        "G5964",
        "G5965",
        "G5966",
        "G5967",
        "G5968",
        "G5969",
        "G5970",
        "G5971",
        "G5972",
        "G5973",
        "G5974",
        "G5975",
        "G5976",
        "G5977",
        "G5978",
        "G5979",
        "G5980",
        "G5981",
        "G5982",
        "G5983",
        "G5984",
        "G5985",
        "G5986",
        "G5987",
        "G5988",
        "G5989",
        "G5990",
        "G5991",
        "G5992",
        "G5993",
        "G5994",
        "G5995",
        "G5996",
        "G5997",
        "G5998",
        "G5999",
        "G6000",
        "G6001",
        "G6002",
        "G6003",
        "G6004",
        "G6005",
        "G6006",
        "G6007",
        "G6008",
        "G6009",
        "G6010",
        "G6011",
        "G6012",
        "G6013",
        "G6014",
        "G6015",
        "G6016",
        "G6017",
        "G6018",
        "G6019",
        "G6020",
        "G6021",
        "G6022",
        "G6023",
        "G6024",
        "G6025",
        "G6026",
        "G6027",
        "G6028",
        "G6029",
        "G6030",
        "G6031",
        "G6032",
        "G6033",
        "G6034",
        "G6035",
        "G6036",
        "G6037",
        "G6038",
        "G6039",
        "G6040",
        "G6041",
        "G6042",
        "G6043",
        "G6044",
        "G6045",
        "G6046",
        "G6047",
        "G6048",
        "G6049",
        "G6050",
        "G6051",
        "G6052",
        "G6053",
        "G6054",
        "G6055",
        "G6056",
        "G6057",
        "G6058",
        "G6059",
        "G6060",
        "G6061",
        "G6062",
        "G6063",
        "G6064",
        "G6065",
        "G6066",
        "G6067",
        "G6068",
        "G6069",
        "G6070",
        "G6071",
        "G6072",
        "G6073",
        "G6074",
        "G6075",
        "G6076",
        "G6077",
        "G6078",
        "G6079",
        "G6080",
        "G6081",
        "G6082",
        "G6083",
        "G6084",
        "G6085",
        "G6086",
        "G6087",
        "G6088",
        "G6089",
        "G6090",
        "G6091",
        "G6092",
        "G6093",
        "G6094",
        "G6095",
        "G6096",
        "G6097",
        "G6098",
        "G6099",
        "G6100",
        "G6101",
        "G6102",
        "G6103",
        "G6104",
        "G6105",
        "G6106",
        "G6107",
        "G6108",
        "G6109",
        "G6110",
        "G6111",
        "G6112",
        "G6113",
        "G6114",
        "G6115",
        "G6116",
        "G6117",
        "G6118",
        "G6119",
        "G6120",
        "G6121",
        "G6122",
        "G6123",
        "G6124",
        "G6125",
        "G6126",
        "G6127",
        "G6128",
        "G6129",
        "G6130",
        "G6131",
        "G6132",
        "G6133",
        "G6134",
        "G6135",
        "G6136",
        "G6137",
        "G6138",
        "G6139",
        "G6140",
        "G6141",
        "G6142",
        "G6143",
        "G6144",
        "G6145",
        "G6146",
        "G6147",
        "G6148",
        "G6149",
        "G6150",
        "G6151",
        "G6152",
        "G6153",
        "G6154",
        "G6155",
        "G6156",
        "G6157",
        "G6158",
        "G6159",
        "G6160",
        "G6161",
        "G6162",
        "G6163",
        "G6164",
        "G6165",
        "G6166",
        "G6167",
        "G6168",
        "G6169",
        "G6170",
        "G6171",
        "G6172",
        "G6173",
        "G6174",
        "G6175",
        "G6176",
        "G6177",
        "G6178",
        "G6179",
        "G6180",
        "G6181",
        "G6182",
        "G6183",
        "G6184",
        "G6185",
        "G6186",
        "G6187",
        "G6188",
        "G6189",
        "G6190",
        "G6191",
        "G6192",
        "G6193",
        "G6194",
        "G6195",
        "G6196",
        "G6197",
        "G6198",
        "G6199",
        "G6200",
        "G6201",
        "G6202",
        "G6203",
        "G6204",
        "G6205",
        "G6206",
        "G6207",
        "G6208",
        "G6209",
        "G6210",
        "G6211",
        "G6212",
        "G6213",
        "G6214",
        "G6215",
        "G6216",
        "G6217",
        "G6218",
        "G6219",
        "G6220",
        "G6221",
        "G6222",
        "G6223",
        "G6224",
        "G6225",
        "G6226",
        "G6227",
        "G6228",
        "G6229",
        "G6230",
        "G6231",
        "G6232",
        "G6233",
        "G6234",
        "G6235",
        "G6236",
        "G6237",
        "G6238",
        "G6239",
        "G6240",
        "G6241",
        "G6242",
        "G6243",
        "G6244",
        "G6245",
        "G6246",
        "G6247",
        "G6248",
        "G6249",
        "G6250",
        "G6251",
        "G6252",
        "G6253",
        "G6254",
        "G6255",
        "G6256",
        "G6257",
        "G6258",
        "G6259",
        "G6260",
        "G6261",
        "G6262",
        "G6263",
        "G6264",
        "G6265",
        "G6266",
        "G6267",
        "G6268",
        "G6269",
        "G6270",
        "G6271",
        "G6272",
        "G6273",
        "G6274",
        "G6275",
        "G6276",
        "G6277",
        "G6278",
        "G6279",
        "G6280",
        "G6281",
        "G6282",
        "G6283",
        "G6284",
        "G6285",
        "G6286",
        "G6287",
        "G6288",
        "G6289",
        "G6290",
        "G6291",
        "G6292",
        "G6293",
        "G6294",
        "G6295",
        "G6296",
        "G6297",
        "G6298",
        "G6299",
        "G6300",
        "G6301",
        "O829",
        "O9786"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<15000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 285,
            "lng": 135,
            "e13": 105,
            "mc": 90,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 150,
            "kes": 420,
            "vs": 165
          }
        },
        {
          "criteria": {
            "lengthInCm": "<20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 150,
            "kes": 420,
            "vs": 165
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 150,
            "kes": 420,
            "vs": 165
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "Ertskade (EECV)"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G6302",
        "G6303",
        "G6304",
        "G6305",
        "G6306",
        "G6307",
        "G6308",
        "G6309",
        "G6310",
        "G6311",
        "G6312",
        "G6313",
        "G6314",
        "G6315",
        "G6316",
        "G6317",
        "G6318",
        "G6319",
        "G6320",
        "O9511"
      ],
      "durations": [
        {
          "criteria": {
            "draughtInCm": "<1430",
            "mooringSide": "SB"
          },
          "minutesFrom": {
            "rv": 285,
            "lng": 135,
            "e13": 105,
            "mc": 90,
            "rb": 120,
            "vo": 225,
            "kas": 345,
            "dh": 135,
            "kes": 405,
            "vs": 150
          }
        },
        {
          "criteria": {
            "draughtInCm": "<1430",
            "mooringSide": "BB"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 120,
            "vo": 225,
            "kas": 345,
            "dh": 135,
            "kes": 405,
            "vs": 150
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430",
            "mooringSide": "SB"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430",
            "mooringSide": "BB"
          },
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150
          }
        },
        {
          "criteria": {
            "draughtInCm": "<1430",
            "mooringSide": "NoPreference"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 120,
            "vo": 225,
            "kas": 345,
            "dh": 135,
            "kes": 405,
            "vs": 150
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430",
            "mooringSide": "NoPreference"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "draughtInCm": "<1430",
            "mooringSide": "Alongside"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 120,
            "vo": 225,
            "kas": 345,
            "dh": 135,
            "kes": 405,
            "vs": 150
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430",
            "mooringSide": "Alongside"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "Nijlhaven - Tennesseehaven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G6321",
        "G6322",
        "G6323",
        "G6324",
        "G6325",
        "G6326",
        "G6327",
        "G6328",
        "G6329",
        "G6330",
        "G6331",
        "G6332",
        "G6333",
        "G6334",
        "G6335",
        "G6336",
        "G6337",
        "G6338",
        "G6339",
        "G6340",
        "G6341",
        "G6342",
        "G6343",
        "G6344",
        "G6345",
        "G6346",
        "G6347",
        "G6348",
        "G6349",
        "G6350",
        "G6351",
        "G6352",
        "G6353",
        "G6354",
        "G6355",
        "G6356",
        "G6357",
        "G6358",
        "G6359",
        "G6360",
        "G9875",
        "G9876",
        "G9877",
        "G9878",
        "G9879",
        "G9880",
        "G9881",
        "G9882",
        "G9883",
        "G9884",
        "G9885"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<18000"
          },
          "minutesFrom": {
            "rv": 285,
            "lng": 135,
            "e13": 105,
            "mc": 90,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 180,
            "kes": 420,
            "vs": 195
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=18000"
          },
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "6e Pet"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G6361",
        "G6362",
        "G6363",
        "G6364",
        "G6365",
        "G6366",
        "G6367",
        "G6368",
        "G6369",
        "G6370",
        "G6371",
        "G6372",
        "G6373",
        "G6374",
        "G6375",
        "G6376",
        "G6377",
        "G6378",
        "G6379",
        "G6380",
        "G6381",
        "G6382",
        "G6383",
        "G6384",
        "G6385",
        "G6386",
        "G6387",
        "G6388",
        "G6389",
        "G6390",
        "G6391",
        "G6392",
        "G6393",
        "G6394",
        "G6395",
        "G6396",
        "G6397",
        "G6398",
        "G6399",
        "G6400",
        "G6401",
        "G6402",
        "G6403",
        "G6404",
        "G6405",
        "G6406",
        "G6407",
        "G6408",
        "G6409",
        "G6410",
        "G6411",
        "G6412",
        "G6413",
        "G6414",
        "G6415",
        "G6416",
        "G6417",
        "G6418",
        "G6419",
        "G6420",
        "G6421",
        "G6422",
        "G6423",
        "G6424",
        "G6425",
        "G6426",
        "G6427",
        "G6428",
        "G6429",
        "G6430"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 150,
            "vo": 255,
            "kas": 375,
            "dh": 180,
            "kes": 435,
            "vs": 195
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120
          }
        },
        {
          "criteria": {
            "draughtInCm": ">1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "Mississippihaven-Hartelhaven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G7020",
        "G7021",
        "G7022",
        "G7023",
        "G7024",
        "G7025",
        "G7026",
        "G7027",
        "G7028",
        "G7029",
        "G7030",
        "G7031",
        "G7032",
        "G7033",
        "G7034",
        "G7035",
        "G7036",
        "G7037",
        "G7038",
        "G7039",
        "G7040",
        "G7041",
        "G7042",
        "G7043",
        "G7044",
        "G7045",
        "G7046",
        "G7047",
        "G7048",
        "G7049",
        "G7050",
        "G7051",
        "G7052",
        "G7053",
        "G7054",
        "G7055",
        "G7056",
        "G7057",
        "G7058",
        "G7059",
        "G7060",
        "G7061",
        "G7062",
        "G7063",
        "G7064",
        "G7065",
        "G7066",
        "G7067",
        "G7068",
        "G7069",
        "G7070",
        "G7071",
        "G7072",
        "G7073",
        "G7074",
        "G7075",
        "G7076",
        "G7077",
        "G7078",
        "G7079",
        "G7080",
        "G7081",
        "G7082",
        "G7083",
        "G7084",
        "G7085",
        "G7086",
        "G7087",
        "G7088",
        "G7089",
        "G7090",
        "G7091",
        "G7092",
        "G7093",
        "G7094",
        "G7095",
        "G7096",
        "G7097",
        "G7098",
        "G7099",
        "G7100",
        "G7101",
        "G7102",
        "G7103",
        "G7104",
        "G7105",
        "G7106",
        "G7107",
        "G7108",
        "G7109",
        "G7110",
        "G7111",
        "G7112",
        "G7113",
        "G7114",
        "G7115",
        "G7116",
        "G7117",
        "G7118",
        "G7119",
        "G7120",
        "G7121",
        "G7122",
        "G7123",
        "G7124",
        "G7125",
        "G7126",
        "G7127",
        "G7128",
        "G7129",
        "G7130",
        "G7131",
        "G7132",
        "G7133",
        "G7134",
        "G7135",
        "G7136",
        "G7137",
        "G7138",
        "G7139",
        "G7140",
        "G7141",
        "G7142",
        "G7143",
        "G7144",
        "G7145",
        "G7146",
        "G7147",
        "G7148",
        "G7149",
        "G7150",
        "G7151",
        "G7152",
        "G7153",
        "G7154",
        "G7155",
        "G7156",
        "G7157",
        "G7158",
        "G7159",
        "G7160",
        "G7161",
        "G7162",
        "G7163",
        "G7164",
        "G7165",
        "G7166",
        "G7167",
        "G7168",
        "G7169",
        "G7170",
        "G7171",
        "G7172",
        "G7173",
        "G7174",
        "G7175",
        "G7176",
        "G7177",
        "G7178",
        "G7179",
        "G7180",
        "G7181",
        "G7182",
        "G7183",
        "G7184",
        "G7185",
        "G7186",
        "G7187",
        "G7188",
        "G7189",
        "G7190",
        "G7191",
        "G7192",
        "G7193",
        "G7194",
        "G7195",
        "G7196",
        "G7197",
        "G7198",
        "G7199",
        "G7200",
        "G7201",
        "G7202",
        "G7203",
        "G7204",
        "G7205",
        "G7206",
        "G7207",
        "G7208",
        "G7209",
        "G7210",
        "G7211",
        "G7212",
        "G7213",
        "G7214",
        "G7215",
        "G7216",
        "G7217",
        "G7218",
        "G7219",
        "G7220",
        "G7221",
        "G7222",
        "G7223",
        "G7224",
        "G7225",
        "G7226",
        "G7227",
        "G7228",
        "G7229",
        "G7230",
        "G7231",
        "G7232",
        "G7233",
        "G7234",
        "G7235",
        "G7236",
        "G7237",
        "G7238",
        "G7239",
        "G7240",
        "G7241",
        "G7242",
        "G7243",
        "G7244",
        "G7245",
        "G7246",
        "G7247",
        "G7248",
        "G7249",
        "G7250",
        "G7251",
        "G7252",
        "G7253",
        "G7254",
        "G7255",
        "G7256",
        "G7257",
        "G7258",
        "G7259",
        "G7260",
        "G7261",
        "G7262",
        "G7263",
        "G7264",
        "G7265",
        "G7266",
        "G7267",
        "G7268",
        "G7269",
        "G7270",
        "G7271",
        "G7272",
        "G7273",
        "G7274",
        "G7275",
        "G7276",
        "G7277",
        "G7278",
        "G7279",
        "G7280",
        "G7281",
        "G7282",
        "G7283",
        "G7284",
        "G7285",
        "G7286",
        "G7287",
        "G7288",
        "G7289",
        "G7290",
        "G7291",
        "G7292",
        "G7293",
        "G7294",
        "G7295",
        "G7296",
        "G7297",
        "G7298",
        "G7299",
        "G7300",
        "G7301",
        "G7302",
        "G7303",
        "G7304",
        "G7305",
        "G7306",
        "G7307",
        "G7308",
        "G7309",
        "G7310",
        "G7311",
        "G7312",
        "G7313",
        "G7314",
        "G7315",
        "G7316",
        "G7317",
        "G7318",
        "G7319",
        "G7320",
        "G7321",
        "G7322",
        "G7323",
        "G7324",
        "G7325",
        "G7326",
        "G7327",
        "G7328",
        "G7329",
        "G7330",
        "G7331",
        "G7332",
        "G7333",
        "G7334",
        "G7335",
        "G7336",
        "G7337",
        "G7338",
        "G7339",
        "G7340",
        "G7341",
        "G7342",
        "G7343",
        "G7344",
        "G7345",
        "G7346",
        "G7347",
        "G7348",
        "G7349",
        "G7350",
        "G7351",
        "G7352",
        "G7353",
        "G7354",
        "G7355",
        "G7356",
        "G7357",
        "G7358",
        "G7359",
        "G7360",
        "G7361",
        "G7362",
        "G7363",
        "G7364",
        "G7365",
        "G7366",
        "G7367",
        "G7368",
        "G7369",
        "G7370",
        "G7371",
        "G7372",
        "G7373",
        "G7374",
        "G7375",
        "G7376",
        "G7377",
        "G7378",
        "G7379",
        "G7380",
        "G7381",
        "G7382",
        "G7383",
        "G7384",
        "G7385",
        "G7386",
        "G7387",
        "G7388",
        "G7389",
        "G7390",
        "G7391",
        "G7392",
        "G7393",
        "G7394",
        "G7395",
        "G7396",
        "G7397",
        "G7398",
        "G7399",
        "G7400",
        "G7401",
        "G7402",
        "G7403",
        "G7404",
        "G7405",
        "G7406",
        "G7407",
        "G7408",
        "G7409",
        "G7410",
        "G7411",
        "G7412",
        "G7413",
        "G7414",
        "G7415",
        "G7416",
        "G7417",
        "G7418",
        "G7419",
        "G7420",
        "G7421",
        "G7422",
        "G7423",
        "G7424",
        "G7425",
        "G7426",
        "G7427",
        "G7428",
        "G7429",
        "G7430",
        "G7431",
        "G7432",
        "G7433",
        "G7434",
        "G7435",
        "G7436",
        "G7437",
        "G7438",
        "G7439",
        "G7440",
        "G7441",
        "G7442",
        "G7443",
        "G7444",
        "G7445",
        "G7446",
        "G7447",
        "G7448",
        "G7449",
        "G7450",
        "G7451",
        "G7452",
        "G7453",
        "G7454",
        "G7455",
        "G7456",
        "G7457",
        "G7458",
        "G7459",
        "G7460",
        "G7461",
        "G7462",
        "G7463",
        "G7464",
        "G7465",
        "G7466",
        "G7467",
        "G7468",
        "G7469",
        "G7470",
        "G7471",
        "G7472",
        "G7473",
        "G7474",
        "G7475",
        "G7476",
        "G7477",
        "G7478",
        "G7479",
        "G7480",
        "G7481",
        "G7482",
        "G7483",
        "G7484",
        "G7485",
        "G7486",
        "G7487",
        "G7488",
        "G7489",
        "G7490",
        "G7491",
        "G7492",
        "G7493",
        "G7494",
        "G7495",
        "G7496",
        "G7497",
        "G7498",
        "G7499",
        "G7500",
        "G7501",
        "G7502",
        "G7503",
        "G7504",
        "G7505",
        "G7506",
        "G7507",
        "G7508",
        "G7509",
        "G7510",
        "G7511",
        "G7512",
        "G7513",
        "G7514",
        "G7515",
        "G7516",
        "G7517",
        "G7518",
        "G7519",
        "G7520",
        "G7521",
        "G7522",
        "G7523",
        "G7524",
        "G7525",
        "G7526",
        "G7527",
        "G7528",
        "G7529",
        "G7530",
        "G7531",
        "G7532",
        "G7533",
        "G7534",
        "G7535",
        "G7536",
        "G7537",
        "G7538",
        "G7539",
        "G7540",
        "G7541",
        "G7542",
        "G7543",
        "G7544",
        "G7545",
        "G7546",
        "G7547",
        "G7548",
        "G7549",
        "G7550",
        "G7551",
        "G7552",
        "G7553",
        "G7554",
        "G7555",
        "G7556",
        "G7557",
        "G7558",
        "G7559",
        "G7560",
        "G7561",
        "G7562",
        "G7563",
        "G7564",
        "G7565",
        "G7566",
        "G7567",
        "G7568",
        "G7569",
        "G7570",
        "G7571",
        "G7572",
        "G7573",
        "G7574",
        "G7575",
        "G7576",
        "G7577",
        "G7578",
        "G7579",
        "G7580",
        "G7581",
        "G7582",
        "G7583",
        "G7584",
        "G7585",
        "G7586",
        "G7587",
        "G7588",
        "G7589",
        "G7590",
        "G7591",
        "G7592",
        "G7593",
        "G7594",
        "G7595",
        "G7596",
        "G7597",
        "G7598",
        "G7599",
        "G7600",
        "G7601",
        "G7602",
        "G7603",
        "G7604",
        "G7605",
        "G7606",
        "G7607",
        "G7608",
        "G7609",
        "G7610",
        "G7611",
        "G7612",
        "G7613",
        "G7614",
        "G7615",
        "G7616",
        "G7617",
        "G7618",
        "G7619",
        "G7620",
        "G7621",
        "G7622",
        "G7623",
        "G7624",
        "G7625",
        "G7626",
        "G7627",
        "G7628",
        "G7629",
        "G7630",
        "G7631",
        "G7632",
        "G7633",
        "G7634",
        "G7635",
        "G7636",
        "G7637",
        "G7638",
        "G7639",
        "G7640",
        "G7641",
        "G7642",
        "G7643",
        "G7644",
        "G7645",
        "G7646",
        "G7647",
        "G7648",
        "G7649",
        "G7650",
        "G7651",
        "G7652",
        "G7653",
        "G7654",
        "G7655",
        "G7656",
        "G7657",
        "G7658",
        "G7659",
        "G7660",
        "G7661",
        "G7662",
        "G7663",
        "G7664",
        "G7665",
        "G7666",
        "G7667",
        "G7668",
        "G7669",
        "G7670",
        "G7671",
        "G7672",
        "G7673",
        "G7674",
        "G7675",
        "G7676",
        "G7677",
        "G7678",
        "G7679",
        "G7680",
        "G7681",
        "G7682",
        "G7683",
        "G7684",
        "G7685",
        "G7686",
        "G7687",
        "G7688",
        "G7689",
        "G7690",
        "G7691",
        "G7692",
        "G7693",
        "G7694",
        "G7695",
        "G7696",
        "G7697",
        "G7698",
        "G7699",
        "G7700",
        "G7701",
        "G7702",
        "G7703",
        "G7704",
        "G7705",
        "G7706",
        "G7707",
        "G7708",
        "G7709",
        "G7710",
        "G7711",
        "G7712",
        "G7713",
        "G7714",
        "G7715",
        "G7716",
        "G7717",
        "G7718",
        "G7719",
        "G7720",
        "G7721",
        "G7722",
        "G7723",
        "G7724",
        "G7725",
        "G7726",
        "G7727",
        "G7728",
        "G7729",
        "G7730",
        "G7731",
        "G7732",
        "G7733",
        "G7734",
        "G7735",
        "G7736",
        "G7737",
        "G7738",
        "G7739",
        "G7740",
        "G7741",
        "G7742",
        "G7743",
        "G7744",
        "G7745",
        "G7746",
        "G7747",
        "G7748",
        "G7749",
        "G7750",
        "G7751",
        "G7752",
        "G7753",
        "G7754",
        "G7755",
        "G7756",
        "G7757",
        "G7758",
        "G7759",
        "G7760",
        "G7761",
        "G7762",
        "G7763",
        "G7764",
        "G7765",
        "G7766",
        "G7767",
        "G7768",
        "G7769",
        "G7770",
        "G7771",
        "G7772",
        "G7773",
        "G7774",
        "G7775",
        "G7776",
        "G7777",
        "G7778",
        "G7779",
        "G7780",
        "G7781",
        "G7782",
        "G7783",
        "G7784",
        "G7785",
        "G7786",
        "G7787",
        "G7788",
        "G7789",
        "G7790",
        "G7791",
        "G7792",
        "G7793",
        "G7794",
        "G7795",
        "G7796",
        "G7797",
        "G7798",
        "G7799",
        "G7800",
        "G7801",
        "G7802",
        "G7803",
        "G7804",
        "G7805",
        "G7806",
        "G7807",
        "G7808",
        "G7809",
        "G7810",
        "G7811",
        "G7812",
        "G7813",
        "G7814",
        "G7815",
        "G7816",
        "G7817",
        "G7818",
        "G7819",
        "G7820",
        "G7821",
        "G7822",
        "G7823",
        "G7824",
        "G7825",
        "G7826",
        "G7827",
        "G7828",
        "G7829",
        "G7830",
        "G7831",
        "G7832",
        "G7833",
        "G7834",
        "G7835",
        "G7836",
        "G7837",
        "G7838",
        "G7839",
        "G7840",
        "G7841",
        "G7842",
        "G7843",
        "G7844",
        "G7845",
        "G7846",
        "G7847",
        "G7848",
        "G7849",
        "G7850",
        "G7851",
        "G7852",
        "G7853",
        "G7854",
        "G7855",
        "G7856",
        "G7857",
        "G7858",
        "G7859",
        "G7860",
        "G7861",
        "G7862",
        "G7863",
        "G7864",
        "G7865",
        "G7866",
        "G7867",
        "G7868",
        "G7869",
        "G7870",
        "G7871",
        "G7872",
        "G7873",
        "G7874",
        "G7875",
        "G7876",
        "G7877",
        "G7878",
        "G7879",
        "G7880",
        "G7881",
        "G7882",
        "G7883",
        "G7884",
        "G7885",
        "G7886",
        "G7887",
        "G7888",
        "G7889",
        "G7890",
        "G7891",
        "G7892",
        "G7893",
        "G7894",
        "G7895",
        "G7896",
        "G7897",
        "G7898",
        "G7899",
        "G7900",
        "G7901",
        "G7902",
        "G7903",
        "G7904",
        "G7905",
        "G7906",
        "G7907",
        "G7908",
        "G7909",
        "G7910",
        "G7911",
        "G7912",
        "G7913",
        "G7914",
        "G7915",
        "G7916",
        "G7917",
        "G7918",
        "G7919",
        "G7920",
        "G7921",
        "G7922",
        "G7923",
        "G7924",
        "G7925",
        "G7926",
        "G7927",
        "G7928",
        "G7929",
        "G7930",
        "G7931",
        "G7932",
        "G7933",
        "G7934",
        "G7935",
        "G7936",
        "G7937",
        "G7938",
        "G7939",
        "G7940",
        "G7941",
        "G7942",
        "G7943",
        "G7944",
        "G7945",
        "G7946",
        "G7947",
        "G7948",
        "G7949",
        "G7950",
        "G7951",
        "G7952",
        "G7953",
        "G7954",
        "G7955",
        "G7956",
        "G7957",
        "G7958",
        "G7959",
        "G7960",
        "G7961",
        "G7962",
        "G7963",
        "G7964",
        "G7965",
        "G7966",
        "G7967",
        "G7968",
        "G7969",
        "G7970",
        "G7971",
        "G7972",
        "G7973",
        "G7974",
        "G7975",
        "G7976",
        "G7977",
        "G7978",
        "G7979",
        "G7980",
        "G7981",
        "G7982",
        "G7983",
        "G7984",
        "G7985",
        "G7986",
        "G7987",
        "G7988",
        "G7989",
        "G7990",
        "G7991",
        "G7992",
        "G7993",
        "G7994",
        "G7995",
        "G7996",
        "G7997",
        "G7998",
        "G7999",
        "G8000",
        "G8001",
        "G8002",
        "G8003",
        "G8004",
        "G8005",
        "G8006",
        "G8007",
        "G8008",
        "G8009",
        "G8010",
        "G8011",
        "G8012",
        "G8013",
        "G8014",
        "G8015",
        "G8016",
        "G8017",
        "G8018",
        "G8019",
        "G8020",
        "G8021",
        "G8022",
        "G8023",
        "G8024",
        "G8025",
        "G8026"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105,
            "rb": 150,
            "vo": 255,
            "kas": 375,
            "dh": 195,
            "kes": 435,
            "vs": 210
          }
        },
        {
          "criteria": {
            "lengthInCm": ">=20000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "8e Pet"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G9860",
        "G9861",
        "G9862",
        "G9863",
        "G9864",
        "G9865",
        "G9866",
        "G9867",
        "G9868",
        "G9869",
        "G9870",
        "G9871",
        "G9872",
        "G9873",
        "G9874"
      ],
      "durations": [
        {
          "criteria": {
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 180,
            "kes": 420,
            "vs": 195
          }
        },
        {
          "criteria": {
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Yukonhaven - Yangtzekanaal (EMX)",
        "Europahaven-FWP A,2,3",
        "Amazonehaven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G8239",
        "G8240",
        "G8241",
        "G8242",
        "G8243",
        "G8244",
        "G8245",
        "G8246",
        "G8247",
        "G8248",
        "G8249",
        "G8250",
        "G8251",
        "G8252",
        "G8253",
        "G8254",
        "G8255",
        "G8256",
        "G8257",
        "G8258",
        "G8259",
        "G8260",
        "G8261",
        "G8262",
        "G8263",
        "G8264",
        "G8265",
        "G8266",
        "G8267",
        "G8268",
        "G8269",
        "G8270",
        "G8271",
        "G8272",
        "G8273",
        "G8274",
        "G8275",
        "G8276",
        "G8277",
        "G8278",
        "G8279",
        "G8280",
        "G8281",
        "G8282",
        "G8283",
        "G8284",
        "G8285",
        "G8286",
        "G8287",
        "G8288",
        "G8289",
        "G8290",
        "G8291",
        "G8292",
        "G8293",
        "G8294",
        "G8295",
        "G8296",
        "G8297",
        "G8298",
        "G8299",
        "G8300",
        "G9825",
        "G9826",
        "G9827",
        "G9828",
        "G9829",
        "G9830",
        "G9831",
        "G9832",
        "G9833",
        "G9834",
        "G9835",
        "G9836",
        "G9837",
        "G9838",
        "G9839",
        "G9840",
        "G9841",
        "G9842",
        "G9843",
        "G9844",
        "G9845",
        "G9846",
        "G9847",
        "G9848",
        "G9849",
        "G9850",
        "G9851",
        "G9852",
        "G9853",
        "G9854",
        "G9855",
        "G9856",
        "G9857",
        "G9858",
        "G9859",
        "G70",
        "G71",
        "G85",
        "G8027",
        "G8028",
        "G8029",
        "G8030",
        "G8031",
        "G8032",
        "G8033",
        "G8034",
        "G8035",
        "G8036",
        "G8037",
        "G8038",
        "G8039",
        "G8040",
        "G8041",
        "G8042",
        "G8043",
        "G8044",
        "G8045",
        "G8046",
        "G8047",
        "G8048",
        "G8049",
        "G8050",
        "G8051",
        "G8052",
        "G8053",
        "G8054",
        "G8055",
        "G8056",
        "G8057",
        "G8058",
        "G8059",
        "G8060",
        "G8061",
        "G8062",
        "G8063",
        "G8064",
        "G8065",
        "G8066",
        "G8067",
        "G8068",
        "G8069",
        "G8070",
        "G8071",
        "G8072",
        "G8073",
        "G8074",
        "G8075",
        "G8076",
        "G8077",
        "G8078",
        "G8079",
        "G8080",
        "G8081",
        "G8082",
        "G8083",
        "G8084",
        "G8085",
        "G8086",
        "G8087",
        "G8088",
        "G8089",
        "G8090",
        "G8091",
        "G8092",
        "G8093",
        "G8094",
        "G8095",
        "G8096",
        "G8097",
        "G8098",
        "G8099",
        "G8100",
        "G8101",
        "G8102",
        "G8103",
        "G8104",
        "G8105",
        "G8106",
        "G8107",
        "G8108",
        "G8109",
        "G8110",
        "G8111",
        "G8112",
        "G8113",
        "G8114",
        "G8115",
        "G8116",
        "G8117",
        "G8118",
        "G8119",
        "G8120",
        "G8121",
        "G8122",
        "G8123",
        "G8124",
        "G8125",
        "G8126",
        "G8127",
        "G8128",
        "G8129",
        "G8130",
        "G8131",
        "G8132",
        "G8133",
        "G8134",
        "G8135",
        "G8136",
        "G8137",
        "G8138",
        "G8139",
        "G8140",
        "G8141",
        "G8142",
        "G8143",
        "G8144",
        "G8145",
        "G8146",
        "G8147",
        "G8148",
        "G8149",
        "G8150",
        "G8151",
        "G8152",
        "G8153",
        "G8154",
        "G8155",
        "G8156",
        "G8157",
        "G8158",
        "G8159",
        "G8160",
        "G8161",
        "G8162",
        "G8163",
        "G8164",
        "G8165",
        "G8166",
        "G8167",
        "G8168",
        "G8169",
        "G8170",
        "G8171",
        "G8172",
        "G8173",
        "G8174",
        "G8175",
        "G8176",
        "G8177",
        "G8178",
        "G8179",
        "G8180",
        "G8181",
        "G8182",
        "G8183",
        "G8184",
        "G8185",
        "G8186",
        "G8187",
        "G8188",
        "G8189",
        "G8190",
        "G8191",
        "G8192",
        "G8193",
        "G8194",
        "G8195",
        "G8196",
        "G8197",
        "G8198",
        "G8199",
        "G8200",
        "G8201",
        "G8202",
        "G8203",
        "G8204",
        "G8205",
        "G8206",
        "G8207",
        "G8208",
        "G8209",
        "G8210",
        "G8211",
        "G8212",
        "G8213",
        "G8214",
        "G8215",
        "G8216",
        "G8217",
        "G8218",
        "G8219",
        "G8220",
        "G8221",
        "G8222",
        "G8223",
        "G8224",
        "G8225",
        "G8226",
        "G8227",
        "G8228",
        "G8229",
        "G8230",
        "G8231",
        "G8232",
        "G8233",
        "G8234",
        "G8235",
        "G8236",
        "G8237",
        "G8238",
        "O4309",
        "O4310",
        "O4311",
        "O4312",
        "O9894",
        "O9796",
        "G8177"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000"
          },
          "minutesFrom": {
            "rv": 285,
            "lng": 135,
            "e13": 105,
            "mc": 90,
            "rb": 135,
            "vo": 240,
            "kas": 360,
            "dh": 180,
            "kes": 420,
            "vs": 195
          }
        },
        {
          "criteria": {
            "lengthInCm": "<30000"
          },
          "minutesFrom": {
            "rv": 300,
            "lng": 150,
            "e13": 120,
            "mc": 105
          }
        },
        {
          "criteria": {
            "lengthInCm": "<=35000"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">35000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 165,
            "e13": 135,
            "mc": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">35000",
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        }
      ]
    },
    {
      "descriptions": [
        "Hartelmond"
      ],
      "berths": [
        "G5006"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150,
            "rb": 75,
            "vo": 180,
            "kas": 300,
            "dh": 90,
            "kes": 360,
            "vs": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Palen 90 - 91 MV2 &"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G90",
        "G91",
        "G92",
        "G9193",
        "G9811",
        "G9812",
        "G9813",
        "G9814",
        "G9815",
        "G9816",
        "G9817",
        "G9818",
        "G9819",
        "G9820",
        "G9821",
        "G9822",
        "G9823",
        "G9824"
      ],
      "durations": [
        {
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165,
            "rb": 150,
            "vo": 255,
            "kas": 375,
            "dh": 195,
            "kes": 435,
            "vs": 210
          }
        }
      ]
    },
    {
      "descriptions": [
        "Amaliahaven"
      ],
      "harbourArea": "Europoort",
      "berths": [
        "G8301",
        "G8302",
        "G8303",
        "G8304",
        "G8305",
        "G8306",
        "G8307",
        "G8308",
        "G8309",
        "G8310",
        "G8311",
        "G8312",
        "G8313",
        "G8314",
        "G8315",
        "G8316",
        "G8317",
        "G8318",
        "G8319",
        "G8320",
        "G8321",
        "G8322",
        "G8323",
        "G8324",
        "G8325",
        "G8326",
        "G8327",
        "G8328",
        "G8329",
        "G8330",
        "G8331",
        "G8332",
        "G8333",
        "G8334",
        "G8335",
        "G8336",
        "G8337",
        "G8338",
        "G8339",
        "G8340",
        "G8341",
        "G8342",
        "G8343",
        "G8344",
        "G8345",
        "G8346",
        "G8347",
        "G8348",
        "G8349",
        "G8350",
        "G8351",
        "G8352",
        "G8353",
        "G8354",
        "G8355",
        "G8356",
        "G8357",
        "G8358",
        "G8359",
        "G8360",
        "G8361",
        "G8362",
        "G8363",
        "G8364",
        "G8365",
        "G8366",
        "G8367",
        "G8368",
        "G8369",
        "G8370",
        "G8371",
        "G8372",
        "G8373",
        "G8374",
        "G8375",
        "G8376",
        "G8377",
        "G8378",
        "G8379",
        "G8380",
        "G8381",
        "G8382",
        "G8383",
        "G8384",
        "G8385",
        "G8386",
        "G8387",
        "G8388",
        "G8389",
        "G8390",
        "G8391",
        "G8392",
        "G8393",
        "G8394",
        "G8395",
        "G8396",
        "G8397",
        "G8398",
        "G8399",
        "G8400",
        "G8401",
        "G8402",
        "G8403",
        "G8404",
        "G8405",
        "G8406",
        "G8407",
        "G8408",
        "G8409",
        "G8410",
        "G8411",
        "G8412",
        "G8413",
        "G8414",
        "G8415",
        "G8416",
        "G8417",
        "G8418",
        "G8419",
        "G8420",
        "G8421",
        "G8422",
        "G8423",
        "G8424",
        "G8425",
        "G8426",
        "G8427",
        "G8428",
        "G8429",
        "G8430",
        "G8431",
        "G8432",
        "G8433",
        "G8434",
        "G8435",
        "G8436",
        "G8437",
        "G8438",
        "G8439",
        "G8440",
        "G8441",
        "G8442",
        "G8443",
        "G8444",
        "G8445",
        "G8446",
        "G8447",
        "G8448",
        "G8449",
        "G8450",
        "G8451",
        "G8452",
        "G8453",
        "G8454",
        "G8455",
        "G8456",
        "G8457",
        "G8458",
        "G8459",
        "G8460",
        "G8461",
        "G8462",
        "G8463",
        "G8464",
        "G8465",
        "G8466",
        "G8467",
        "G8468",
        "G8469",
        "G8470",
        "G8471",
        "G8472",
        "G8473",
        "G8474",
        "G8475",
        "G8476",
        "G8477",
        "G8478",
        "G8479",
        "G8480",
        "G8481",
        "G8482",
        "G8483",
        "G8484",
        "G8485",
        "G8486",
        "G8487",
        "G8488",
        "G8489",
        "G8490",
        "G8491",
        "G8492",
        "G8493",
        "G8494",
        "G8495",
        "G8496",
        "G8497",
        "G8498",
        "G8499",
        "G8500",
        "G8501",
        "G8502",
        "G8503",
        "G8504",
        "G8505",
        "G8506",
        "G8507",
        "G8508",
        "G8509",
        "G8510",
        "G8511",
        "G8512",
        "G8513",
        "G8514",
        "G8515",
        "G8516",
        "G8517",
        "G8518",
        "G8519",
        "G8520",
        "G8521",
        "G8522",
        "G8523",
        "G8524",
        "G8525",
        "G8526",
        "G8527",
        "G8528",
        "G8529",
        "G8530",
        "G8531",
        "G8532",
        "G8533",
        "G8534",
        "G8535",
        "G8536",
        "G8537",
        "G8538",
        "G8539",
        "G8540",
        "G8541",
        "G8542",
        "G8543",
        "G8544",
        "G8545",
        "G8546",
        "G8547",
        "G8548",
        "G8549",
        "G8550",
        "G8551",
        "G8552",
        "G8553",
        "G8554",
        "G8555",
        "G8556",
        "G8557",
        "G8558",
        "G8559",
        "G8560",
        "G8561",
        "G8562",
        "G8563",
        "G8564",
        "G8565",
        "G8566",
        "G8567",
        "G8568",
        "G8569",
        "G8570",
        "G8571",
        "G8572",
        "G8573",
        "G8574",
        "G8575",
        "G8576",
        "G8577",
        "G8578",
        "G8579",
        "G8580",
        "G8581",
        "G8582",
        "G8583",
        "G8584",
        "G8585",
        "G8586",
        "G8587",
        "G8588",
        "G8589",
        "G8590",
        "G8591",
        "G8592",
        "G8593",
        "G8594",
        "G8595",
        "G8596",
        "G8597",
        "G8598",
        "G8599",
        "G8600",
        "G8601",
        "G8602",
        "G8603",
        "G8604",
        "G8605",
        "G8606",
        "G8607",
        "G8608",
        "G8609",
        "G8610",
        "G8611",
        "G8612",
        "G8613",
        "G8614",
        "G8615",
        "G8616",
        "G8617",
        "G8618",
        "G8619",
        "G8620",
        "G8621",
        "G8622",
        "G8623",
        "G8624",
        "G8625",
        "G8626",
        "G8627",
        "G8628",
        "G8629",
        "G8630",
        "G8631",
        "G8632",
        "G8633",
        "G8634",
        "G8635",
        "G8636",
        "G8637",
        "G8638",
        "G8639",
        "G8640",
        "G8641",
        "G8642",
        "G8643",
        "G8644",
        "G8645",
        "G8646",
        "G8647",
        "G8648",
        "G8649",
        "G8650",
        "G8651",
        "G8652",
        "G8653",
        "G8654",
        "G8655",
        "G8656",
        "G8657",
        "G8658",
        "G8659",
        "G8660",
        "G8661",
        "G8662",
        "G8663",
        "G8664",
        "G8665",
        "G8666",
        "G8667",
        "G8668",
        "G8669",
        "G8670",
        "G8671",
        "G8672",
        "G8673",
        "G8674",
        "G8675",
        "G8676",
        "G8677",
        "G8678",
        "G8679",
        "G8680",
        "G8681",
        "G8682",
        "G8683",
        "G8684",
        "G8685",
        "G8686",
        "G8687",
        "G8688",
        "G8689",
        "G8690",
        "G8691",
        "G8692",
        "G8693",
        "G8694",
        "G8695",
        "G8696",
        "G8697",
        "G8698",
        "G8699",
        "G8700",
        "G8701",
        "G8702",
        "G8703",
        "G8704",
        "G8705",
        "G8706",
        "G8707",
        "G8708",
        "G8709",
        "G8710",
        "G8711",
        "G8712",
        "G8713",
        "G8714",
        "G8715",
        "G8716",
        "G8717",
        "G8718",
        "G8719",
        "G8720",
        "G8721",
        "G8722",
        "G8723",
        "G8724",
        "G8725",
        "G8726",
        "G8727",
        "G8728",
        "G8729",
        "G8730",
        "G8731",
        "G8732",
        "G8733",
        "G8734",
        "G8735",
        "G8736",
        "G8737",
        "G8738",
        "G8739",
        "G8740",
        "G8741",
        "G8742",
        "G8743",
        "G8744",
        "G8745",
        "G8746",
        "G8747",
        "G8748",
        "G8749",
        "G8750",
        "G8751",
        "G8752",
        "G8753",
        "G8754",
        "G8755",
        "G8756",
        "G8757",
        "G8758",
        "G8759",
        "G8760",
        "G8761",
        "G8762",
        "G8763",
        "G8764",
        "G8765",
        "G8766",
        "G8767",
        "G8768",
        "G8769",
        "G8770",
        "G8771",
        "G8772",
        "G8773",
        "G8774",
        "G8775",
        "G8776",
        "G8777",
        "G8778",
        "G8779",
        "G8780",
        "G8781",
        "G8782",
        "G8783",
        "G8784",
        "G8785",
        "G8786",
        "G8787",
        "G8788",
        "G8789",
        "G8790",
        "G8791",
        "G8792",
        "G8793",
        "G8794",
        "G8795",
        "G8796",
        "G8797",
        "G8798",
        "G8799",
        "G8800",
        "G8801",
        "G8802",
        "G8803",
        "G8804",
        "G8805",
        "G8806",
        "G8807",
        "G8808",
        "G8809",
        "G8810",
        "G8811",
        "G8812",
        "G8813",
        "G8814",
        "G8815",
        "G8816",
        "G8817",
        "G8818",
        "G8819",
        "G8820",
        "G8821",
        "G8822",
        "G8823",
        "G8824",
        "G8825",
        "G8826",
        "G8827",
        "G8828",
        "G8829",
        "G8830",
        "G8831",
        "G8832",
        "G8833",
        "G8834",
        "G8835",
        "G8836",
        "G8837",
        "G8838",
        "G8839",
        "G8840",
        "G8841",
        "G8842",
        "G8843",
        "G8844",
        "G8845",
        "G8846",
        "G8847",
        "G8848",
        "G8849",
        "G8850",
        "G8851",
        "G8852",
        "G8853",
        "G8854",
        "G8855",
        "G8856",
        "G8857",
        "G8858",
        "G8859",
        "G8860",
        "G8861",
        "G8862",
        "G8863",
        "G8864",
        "G8865",
        "G8866",
        "G8867",
        "G8868",
        "G8869",
        "G8870",
        "G8871",
        "G8872",
        "G8873",
        "G8874",
        "G8875",
        "G8876",
        "G8877",
        "G8878",
        "G8879",
        "G8880",
        "G8881",
        "G8882",
        "G8883",
        "G8884",
        "G8885",
        "G8886",
        "G8887",
        "G8888",
        "G8889",
        "G8890",
        "G8891",
        "G8892",
        "G8893",
        "G8894",
        "G8895",
        "G8896",
        "G8897",
        "G8898",
        "G8899",
        "G8900",
        "G8901",
        "G8902",
        "G8903",
        "G8904",
        "G8905",
        "G8906",
        "G8907",
        "G8908",
        "G8909",
        "G8910",
        "G8911",
        "G8912",
        "G8913",
        "G8914",
        "G8915",
        "G8916",
        "G8917",
        "G8918",
        "G8919",
        "G8920",
        "G8921",
        "G8922",
        "G8923",
        "G8924",
        "G8925",
        "G8926",
        "G8927",
        "G8928",
        "G8929",
        "G8930",
        "G8931",
        "G8932",
        "G8933",
        "G8934",
        "G8935",
        "G8936",
        "G8937",
        "G8938",
        "G8939",
        "G8940",
        "G8941",
        "G8942",
        "G8943",
        "G8944",
        "G8945",
        "G8946",
        "G8947",
        "G8948",
        "G8949",
        "G8950",
        "G8951",
        "G8952",
        "G8953",
        "G8954",
        "G8955",
        "G8956",
        "G8957",
        "G8958",
        "G8959",
        "G8960",
        "G8961",
        "G8962",
        "G8963",
        "G8964",
        "G8965",
        "G8966",
        "G8967",
        "G8968",
        "G8969",
        "G8970",
        "G8971",
        "G8972",
        "G8973",
        "G8974",
        "G8975",
        "G8976",
        "G8977",
        "G8978",
        "G8979",
        "G8980",
        "G8981",
        "O9859",
        "O9861",
        "O9865",
        "O9866",
        "O9899",
        "O9900",
        "O9901"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<20000"
          },
          "minutesFrom": {
            "rv": 315,
            "lng": 365,
            "e13": 135,
            "mc": 120,
            "rb": 165,
            "vo": 270,
            "kas": 390,
            "dh": 210,
            "kes": 450,
            "vs": 225
          }
        },
        {
          "criteria": {
            "lengthInCm": "<30000"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "lengthInCm": "<=35000"
          },
          "minutesFrom": {
            "rv": 330,
            "lng": 180,
            "e13": 150,
            "mc": 135
          }
        },
        {
          "criteria": {
            "lengthInCm": ">35000",
            "draughtInCm": "<1430"
          },
          "minutesFrom": {
            "rv": 345,
            "lng": 195,
            "e13": 165,
            "mc": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">35000",
            "draughtInCm": ">=1430"
          },
          "minutesFrom": {
            "rv": 360,
            "lng": 210,
            "e13": 180,
            "mc": 165
          }
        }
      ]
    }
  ],
  "NLAMS": [
    {
      "descriptions": [
        "ADM Haven",
        "ADM Haven"
      ],
      "berths": [
        "AHADM",
        "AHSTN",
        "AHSTZ",
        "WHDUW"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 150,
            "os": 120,
            "ar": 120,
            "za": 30
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 120,
            "ar": 120,
            "za": 30
          }
        }
      ]
    },
    {
      "descriptions": [
        "Afrikahaven",
        "Afrikahaven"
      ],
      "berths": [
        "AKP1O",
        "AK1NW",
        "AKWS1",
        "AKWS2",
        "AKWS3",
        "AKWS4",
        "AKWS5",
        "AKWS6",
        "AKP1W",
        "AK2E1",
        "AKP2O",
        "AK2E3",
        "AK2W1",
        "AK2W2",
        "AKALG",
        "AKCIT",
        "AKK31",
        "AKK32",
        "AKP2B",
        "AKP2W",
        "AKP4B",
        "AKP4W",
        "AKPLN",
        "AKRIE",
        "AKWPB",
        "AKWPN",
        "AKWPW",
        "AKW01",
        "AKWPZ",
        "MGSCS",
        "MRKZZ",
        "MRK42",
        "MRWPO",
        "MRWPW",
        "ZZWST",
        "ZZOST",
        "ZZWPO",
        "ZZWPW",
        "AKCWS"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 150,
            "os": 180,
            "ar": 180,
            "za": 105
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 180,
            "ar": 180,
            "za": 105
          }
        }
      ]
    },
    {
      "descriptions": [
        "Amerikahaven",
        "Amerikahaven"
      ],
      "berths": [
        "AMIDN",
        "AMTPL",
        "AMTST",
        "AMIDZ",
        "AMALG",
        "AMAPA",
        "AMBO2",
        "AMBO6",
        "AMBRM",
        "AMBRO",
        "AMBUN",
        "AMEMA",
        "AMHCB",
        "AMHCZ",
        "AMGRA",
        "AMPAR",
        "AMHTZ",
        "AMLNG",
        "AMMVL",
        "AMO10",
        "AMO11",
        "AMO12",
        "AMO17",
        "AMO18",
        "AMO19",
        "AMOLI",
        "AMOT1",
        "AMOT2",
        "AMOT3",
        "AMOT4",
        "AMOT5",
        "AMOT6",
        "AMOT7",
        "AMOT8",
        "AMOT9",
        "AMPNM",
        "AMRIE",
        "AMRPL",
        "AMS08",
        "AMS09",
        "AMS10",
        "AMS11",
        "AMSEN",
        "AMVBB",
        "AMBLU",
        "AMWGK",
        "AMWOW",
        "AMWSO",
        "AMBPB",
        "AMBPC",
        "AMOTO",
        "AMWOO",
        "CAALG",
        "CAEMA",
        "CAPAM",
        "CAPIM",
        "TXHCK",
        "TXS14",
        "TXS15",
        "TXS16",
        "TXHCK"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 165,
            "ar": 165,
            "za": 90
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 210,
            "os": 165,
            "ar": 165,
            "za": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Australi�haven",
        "Australi�haven"
      ],
      "berths": [
        "AUAGM",
        "AUALG",
        "AUGRA",
        "AUGRO",
        "AUPAE",
        "AUWSB",
        "AUWSN",
        "AUWSO",
        "AUWSW",
        "AUWSZ",
        "AUBP1",
        "AUBP2",
        "AUBP3",
        "AUBP4",
        "AUBP5",
        "AUBPA",
        "TAAGM",
        "TAGRO"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 165,
            "ar": 165,
            "za": 90
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 240,
            "os": 165,
            "ar": 165,
            "za": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Azi�haven",
        "Azi�haven"
      ],
      "berths": [
        "AZALG",
        "AZARA",
        "AZAVI",
        "AZCMB",
        "AZCMZ",
        "AZPIO",
        "AZRPO",
        "AZRPW",
        "AZRTL",
        "AZZGR",
        "AZLP1"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 165,
            "ar": 165,
            "za": 105
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 240,
            "os": 165,
            "ar": 165,
            "za": 105
          }
        }
      ]
    },
    {
      "descriptions": [
        "Beringhaven",
        "Beringhaven"
      ],
      "berths": [
        "BEALG",
        "MAB1O",
        "MAB1W",
        "MAB2O",
        "MAB2W",
        "BEFE1",
        "BEFE2",
        "BEWIT",
        "BEWSZ",
        "MANWB",
        "MAWO1",
        "MAWO2",
        "MGALG"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 150,
            "ar": 150,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 150,
            "ar": 150,
            "za": 75
          }
        }
      ]
    },
    {
      "descriptions": [
        "Binnenspuikanaal",
        "Binnenspuikanaal"
      ],
      "berths": [
        "BNSPN",
        "BNSN1",
        "BNSN2",
        "BNSN3",
        "BNSN4",
        "BNSN5",
        "BNSZ1",
        "BNSZ2",
        "BNSZ3",
        "BNSZ4",
        "BNSPZ"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 165,
            "os": 210,
            "ar": 210,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "os": 210,
            "ar": 210,
            "za": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Bosporushaven",
        "Bosporushaven"
      ],
      "berths": [
        "BPHST",
        "BPALG",
        "BPHEI",
        "BPHKK",
        "BPHKP",
        "BPHKW",
        "BPHS1",
        "BPHS2",
        "BPNU9"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 150,
            "ar": 150,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 150,
            "ar": 150,
            "za": 75
          }
        }
      ]
    },
    {
      "descriptions": [
        "Buitenhaven BUKA",
        "Buitenhaven BUKA",
        "Buitenhaven BUKA"
      ],
      "berths": [
        "BSKAD",
        "BSPLN",
        "BUALG",
        "BUAMS",
        "BUK2O",
        "BUK2W",
        "BUKA0",
        "BUKA1",
        "BUKA3",
        "BULLK",
        "BUPHK",
        "BUSTE",
        "BUTEE"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 90,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "BB"
          },
          "minutesFrom": {
            "kp": 120,
            "rv": 300,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "SB"
          },
          "minutesFrom": {
            "kp": 135,
            "rv": 300,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "NoPreference"
          },
          "minutesFrom": {
            "kp": 120,
            "rv": 300,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "Alongside"
          },
          "minutesFrom": {
            "kp": 135,
            "rv": 300,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Buitenhaven IJmuiden",
        "Buitenhaven IJmuiden"
      ],
      "berths": [
        "AVPLN",
        "AVPL2",
        "AVALG"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "rv": 270,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Carel Reynierszhaven",
        "Carel Reynierszhaven"
      ],
      "berths": [
        "CRALB",
        "CRALG",
        "CRHEY",
        "CREGM",
        "CRAIM",
        "CRICO",
        "CRMON",
        "CRS16",
        "CRS17"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 150,
            "ar": 150,
            "za": 30
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 150,
            "ar": 150,
            "za": 30
          }
        }
      ]
    },
    {
      "descriptions": [
        "Coenhaven",
        "Coenhaven"
      ],
      "berths": [
        "CHAAM",
        "CHALG",
        "CHAMK",
        "CHAZK",
        "CHCAF",
        "CHCAZ",
        "CHCWA",
        "CHAMF",
        "CHKPW",
        "CHNHD",
        "CHWHD",
        "CHZST"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 90,
            "ar": 90,
            "za": 45
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 90,
            "ar": 90,
            "za": 45
          }
        }
      ]
    },
    {
      "descriptions": [
        "Dirk Metselaarhaven",
        "Dirk Metselaarhaven"
      ],
      "berths": [
        "DMALG",
        "DMKO2",
        "DMKOO",
        "DMKO3",
        "DMSLS",
        "DMZVM",
        "FPALG",
        "FPPLN",
        "GWTAL",
        "IJAA1",
        "IJAA2",
        "IJPLE"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 120,
            "ar": 120,
            "za": 15
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 120,
            "ar": 120,
            "za": 15
          }
        }
      ]
    },
    {
      "descriptions": [
        "Fortput",
        "Fortput"
      ],
      "berths": [
        "FPALG",
        "FPPLN"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "os": 240,
            "ar": 240,
            "za": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Het IJ",
        "Het IJ"
      ],
      "berths": [
        "GWTAL",
        "IJAA1",
        "IJAA2",
        "IJPLE",
        "IJRO1",
        "RKRKO",
        "IJRO2",
        "RKSTA",
        "IJRO3",
        "RKSTB",
        "IJRO4",
        "RKSTC",
        "IJRO5",
        "RKSTD",
        "IJRO6",
        "RKRKW",
        "RK16A",
        "RK16B",
        "RK17A",
        "RK17B",
        "RK18A",
        "RK18B",
        "IJSNH",
        "IJWP5",
        "RK14Z",
        "RK14N",
        "IJWSD",
        "NKTO1",
        "NKTO2",
        "RK15A",
        "RK15B",
        "RKALG",
        "IJGH1",
        "IJGH2",
        "IJGH3"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 60,
            "ar": 60,
            "za": 90
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "os": 60,
            "ar": 60,
            "za": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Het Slik",
        "Het Slik"
      ],
      "berths": [
        "IJP1O",
        "IJP2W",
        "IJP1W",
        "IJP2O",
        "OWBID",
        "OWBUD",
        "OWDOK",
        "OWHBW",
        "OWHEH",
        "OWIJK",
        "SMPA1",
        "SMWPB",
        "SUAA1",
        "SUSUR",
        "SUWS1",
        "SUWS2",
        "SUWS3",
        "SUWS4",
        "SUWS5",
        "SUWS6",
        "ZBFIJ"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 300,
            "os": 30,
            "ar": 30,
            "za": 90
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "os": 30,
            "ar": 30,
            "za": 105
          }
        }
      ]
    },
    {
      "descriptions": [
        "Hornhaven",
        "Hornhaven"
      ],
      "berths": [
        "HHALG",
        "MOGAO",
        "MOGAW",
        "MOKVL",
        "HHDO1",
        "HHOVD",
        "HHWVD",
        "HHBO2",
        "HHDB1",
        "HHDB2",
        "HHDB3",
        "HHPAL",
        "HHDBN",
        "HHDBZ",
        "HHKTN",
        "HHSTE",
        "HHCTA",
        "MOHOO",
        "MOPDK"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 180,
            "ar": 180,
            "za": 90
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 255,
            "os": 180,
            "ar": 180,
            "za": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Houthaven",
        "Houthaven"
      ],
      "berths": [
        "NHALG",
        "NHBEW",
        "NHDAN",
        "NHDSO",
        "NHDSS",
        "NHDSW",
        "NHHGL",
        "NHP10",
        "NHP2N",
        "NHP2Z",
        "NHP3N",
        "NHP3Z",
        "NHP4N",
        "NHP4Z",
        "NHP5N",
        "NHP5Z",
        "NHP6N",
        "NHP6Z",
        "NHPL1",
        "NHPL2",
        "NHPL3",
        "NHPL4",
        "NHPL5",
        "NHPL6",
        "NHPL7",
        "NHPL8",
        "NHPL9",
        "NHWSO",
        "NHWSW"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "za": 60
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "za": 60
          }
        }
      ]
    },
    {
      "descriptions": [
        "IJ-haven",
        "Ijhaven",
        "IJ-haven",
        "IJ-haven",
        "IJ-haven"
      ],
      "berths": [
        "HKPTA",
        "HKALG",
        "JKJK1",
        "JKJK2",
        "JKRC1",
        "JKWPO",
        "VKVKO",
        "VKVKW",
        "VKAA1"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 45,
            "ar": 45,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "SB"
          },
          "minutesFrom": {
            "kp": 270,
            "os": 45,
            "ar": 45,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "BB"
          },
          "minutesFrom": {
            "kp": 300,
            "os": 45,
            "ar": 45,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "NoPreference"
          },
          "minutesFrom": {
            "kp": 270,
            "os": 45,
            "ar": 45,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500",
            "mooringSide": "Alongside"
          },
          "minutesFrom": {
            "kp": 300,
            "os": 45,
            "ar": 45,
            "za": 75
          }
        }
      ]
    },
    {
      "descriptions": [
        "IJmondhaven",
        "IJmondhaven"
      ],
      "berths": [
        "YMALG",
        "YMMON",
        "YMVOL"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 90,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 90,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "IJmuiden",
        "IJmuiden"
      ],
      "berths": [
        "HAALG",
        "HABUK",
        "HABUP",
        "HAHEL",
        "HAKOT",
        "HALOG",
        "HALEO",
        "HALZU",
        "HASTW",
        "VHALG",
        "VHHAL",
        "VHNRM",
        "VHSTG",
        "VHTER",
        "VHZZM",
        "VHZZO",
        "VHZZW",
        "VHWCS"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 90,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 90,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "IJ-Shipdock",
        "IJ-Shipdock"
      ],
      "berths": [
        "SDDO1",
        "SDDO2",
        "SDDO3",
        "SDDO4",
        "FBBOE",
        "IJKNP",
        "SDLLK",
        "SDLP1",
        "SDLP2",
        "SDLP3",
        "SDAFB",
        "SDLP4",
        "SDLP5",
        "SDLP6",
        "AFALG",
        "AFBKP",
        "AFKAD",
        "AFPLN",
        "NZVLI",
        "SDALG",
        "SDNDS",
        "SDVLI"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 210,
            "os": 60,
            "ar": 60,
            "za": 60
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 255,
            "os": 60,
            "ar": 60,
            "za": 60
          }
        }
      ]
    },
    {
      "descriptions": [
        "Isaac Baarthaven",
        "Isaac Baarthaven"
      ],
      "berths": [
        "IBALG",
        "IBBRO",
        "IBJAN",
        "IBKA3",
        "IBSCH",
        "IBJBK"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 210,
            "os": 135,
            "ar": 135,
            "za": 15
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 210,
            "os": 135,
            "ar": 135,
            "za": 15
          }
        }
      ]
    },
    {
      "descriptions": [
        "Jan van Riebeeckhaven",
        "Jan van Riebeeckhaven"
      ],
      "berths": [
        "ADKAD",
        "ADWN1",
        "ADWN2",
        "ADWS1",
        "RBAA1",
        "RBALG",
        "RBNUK",
        "RBS10",
        "RBSLD",
        "RBST3",
        "RBST4",
        "RBST5",
        "RBST6",
        "RBST7",
        "RBST8",
        "RBST9",
        "RBWSN",
        "RBWSZ"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 135,
            "ar": 135,
            "za": 30
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 135,
            "ar": 135,
            "za": 30
          }
        }
      ]
    },
    {
      "descriptions": [
        "Mercuriushaven",
        "Mercuriushaven"
      ],
      "berths": [
        "MEALG",
        "MEB07",
        "MEBK5",
        "MEBKW",
        "MEHVM",
        "MELP5",
        "MEMVL",
        "MEB01",
        "MEB05",
        "MEOLI"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 75,
            "ar": 75,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 300,
            "os": 75,
            "ar": 75,
            "za": 75
          }
        }
      ]
    },
    {
      "descriptions": [
        "Minervahaven",
        "Minervahaven"
      ],
      "berths": [
        "MIALG",
        "MISTB",
        "MIW1N",
        "MIW1Z",
        "MIW2N",
        "MIW2Z",
        "MIWST",
        "MIWZZ"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 75,
            "ar": 75,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Monding ARK",
        "Monding ARK"
      ],
      "berths": [
        "IJBUN",
        "YHBUN",
        "ZBBU2",
        "ZBROD",
        "ZBBUN"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 240,
            "os": 15,
            "ar": 15,
            "za": 165
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "NZK Coen",
        "NZK Coen"
      ],
      "berths": [
        "CHDBN",
        "CHDBZ",
        "CHWPN",
        "CHWPZ",
        "HEKAN",
        "HEKAO",
        "HEKAW",
        "NZJBV",
        "NZMOK",
        "NZMWK",
        "NZOMK",
        "NZOSN",
        "NZWCN",
        "NZWCZ",
        "SDHEM"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "NZK Hoogtij",
        "NZK Hoogtij"
      ],
      "berths": [
        "NZHO1",
        "NZHO2",
        "NZPAR"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 150,
            "os": 135,
            "ar": 135,
            "za": 45
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 165,
            "os": 135,
            "ar": 135,
            "za": 45
          }
        }
      ]
    },
    {
      "descriptions": [
        "NZK Kruithaven",
        "NZK Kruithaven"
      ],
      "berths": [
        "KRPLN",
        "KRST1",
        "KRST2",
        "KRALG",
        "NZNAU"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "NZK Velsen",
        "NZK Velsen"
      ],
      "berths": [
        "VECMF",
        "VEHOU",
        "VEOCT",
        "VEALG"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 135,
            "os": 210,
            "ar": 210,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 150,
            "os": 210,
            "ar": 210,
            "za": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Oosterdok",
        "Oosterdok"
      ],
      "berths": [
        "HKOOS"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 270,
            "os": 60,
            "ar": 60,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Oranjesluis",
        "Oranjesluis"
      ],
      "berths": [
        "IJNGB"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Oude Houthaven",
        "Oude Houthaven"
      ],
      "berths": [
        "HOW1O",
        "OHRF1",
        "OHRF2",
        "OHRF3",
        "HOW1W",
        "HOW2O",
        "HOW2W",
        "HOW3O",
        "HOW3W",
        "HOW4O",
        "HOW4W",
        "OHPS1",
        "OHPS2",
        "OHSBO",
        "OHSBW",
        "OHSCO",
        "OHSCW",
        "OHWLP"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Petroleumhaven",
        "Petroleumhaven"
      ],
      "berths": [
        "PHALG",
        "PHBEV",
        "PHAV1",
        "PHAV2",
        "PHAV3",
        "PHS07",
        "PHS09",
        "PHS12",
        "PHS13",
        "PHS14",
        "PHS15",
        "PHS16",
        "PHS17",
        "PHST1",
        "PHST2"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 105,
            "ar": 105,
            "za": 45
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 105,
            "ar": 105,
            "za": 45
          }
        }
      ]
    },
    {
      "descriptions": [
        "Rijksbinnenhaven 1",
        "Rijksbinnenhaven 1"
      ],
      "berths": [
        "R1CEM",
        "R1PLZ"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "os": 180,
            "ar": 180,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "os": 180,
            "ar": 180,
            "za": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Rijksbinnenhaven 2",
        "Rijksbinnenhaven 2"
      ],
      "berths": [
        "R2KAD",
        "R2KOP",
        "R2PLN",
        "R2UNA",
        "R2ALG"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 90,
            "os": 180,
            "ar": 180,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 120,
            "os": 180,
            "ar": 180,
            "za": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Rijksbinnenhaven 3",
        "Rijksbinnenhaven 3"
      ],
      "berths": [
        "R3AWT",
        "R3KRT",
        "R3NRD",
        "R3WAG",
        "R3WAK",
        "R3ALG"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 120,
            "os": 180,
            "ar": 180,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Seaport Marina",
        "Seaport Marina"
      ],
      "berths": [
        "SPSPM"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 60,
            "os": 270,
            "ar": 270,
            "za": 180
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Sluizencomplex",
        "Sluizencomplex"
      ],
      "berths": [
        "WPSLW",
        "LWKAD",
        "ZTPAS",
        "ZTPLO",
        "ZTPLW"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 60,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 75,
            "os": 240,
            "ar": 240,
            "za": 150
          }
        }
      ]
    },
    {
      "descriptions": [
        "Sonthaven",
        "Sonthaven"
      ],
      "berths": [
        "SOALG",
        "SOHVP",
        "SOMVL",
        "SOKAS",
        "SOKS1",
        "SOKZS",
        "SOKS3",
        "SOKS4",
        "SOTO1",
        "SOTO2",
        "SOW1N",
        "SOW1Z",
        "SOW2N",
        "SOW2Z",
        "SOWEL",
        "SOWSN",
        "SOWSZ",
        "SOHVK"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 150,
            "ar": 150,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 150,
            "ar": 150,
            "za": 75
          }
        }
      ]
    },
    {
      "descriptions": [
        "Staalhaven",
        "Staalhaven"
      ],
      "berths": [
        "STKAD",
        "STPLN"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Suezhaven",
        "Suezhaven"
      ],
      "berths": [
        "SZALG",
        "SZAW4",
        "SZDWA",
        "SZFE3",
        "SZMKA",
        "SZNZY",
        "SZRO1",
        "SZRO2",
        "SZWS1",
        "SZWS2",
        "SZWS3"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 150,
            "ar": 150,
            "za": 90
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 135,
            "ar": 135,
            "za": 90
          }
        }
      ]
    },
    {
      "descriptions": [
        "Usselincxhaven",
        "Usselincxhaven"
      ],
      "berths": [
        "USALG",
        "USS03",
        "USS04",
        "USS05",
        "USS11",
        "USS12",
        "USS13",
        "USS14",
        "USS15",
        "USWSO",
        "USWSW"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 135,
            "ar": 135,
            "za": 30
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 135,
            "ar": 135,
            "za": 30
          }
        }
      ]
    },
    {
      "descriptions": [
        "Vlothaven",
        "Vlothaven"
      ],
      "berths": [
        "ME13A",
        "VLBMN",
        "VLSPA",
        "MEWSO",
        "MEWSW",
        "NEOSP",
        "NEKAD",
        "NEWPK",
        "NEALG",
        "VLALG",
        "VLBO6",
        "VLPAK",
        "VLHOL",
        "VLKAD",
        "VLI10",
        "VLI11",
        "VLLIM",
        "VLLP1",
        "VLLP2",
        "VLLP3",
        "VLLP4",
        "VLP12",
        "VLP13",
        "VLP14",
        "VLP16",
        "VLWES",
        "VLAST"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 195,
            "os": 90,
            "ar": 90,
            "za": 105
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 285,
            "os": 90,
            "ar": 90,
            "za": 105
          }
        }
      ]
    },
    {
      "descriptions": [
        "Westhaven",
        "Westhaven"
      ],
      "berths": [
        "WHACP",
        "WHDB1",
        "WHDB2",
        "WHBD3",
        "WHDB3",
        "WHDB4",
        "WHNOB",
        "WHOT2",
        "WHON4",
        "WHON5",
        "WHOZ2",
        "WHOZ3",
        "WHAA1",
        "WHALG",
        "WHAW2",
        "WHAW3",
        "WHCAR",
        "WHAWT",
        "WHCST",
        "WHDBA",
        "WHDBN",
        "WHDBZ",
        "WHGAS",
        "WHKOO",
        "WHKTN",
        "WHMVL",
        "WHNU5",
        "WHNU6",
        "WHOBA",
        "WHOBN",
        "WHOBZ",
        "WHPLN",
        "WHAPA",
        "WHPLZ",
        "WHROR",
        "WHCON",
        "WHTA1",
        "WHTA2",
        "WHTA3",
        "WHTA4",
        "WHTA5",
        "WHTA6",
        "WHWHB",
        "WHBEE",
        "WHKDN",
        "WHKDZ",
        "WHKPN",
        "WHKPZ",
        "WHKMR"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 135,
            "ar": 135,
            "za": 75
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 225,
            "os": 135,
            "ar": 135,
            "za": 75
          }
        }
      ]
    },
    {
      "descriptions": [
        "Wim Thomassenhaven",
        "Wim Thomassenhaven"
      ],
      "berths": [
        "WTALG",
        "WTCON",
        "WTPIE",
        "WTPLO",
        "WTPLW",
        "WTWPM"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 180,
            "os": 135,
            "ar": 135,
            "za": 45
          }
        },
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Zijkanaal C",
        "Zijkanaal C"
      ],
      "berths": [
        "BVABE",
        "BVNOO",
        "BVNOW",
        "BVALG",
        "BVBEB",
        "BVCON",
        "BVMEB",
        "BVNIE",
        "BVNOR",
        "BVKO1",
        "BVKO2",
        "BVTR1",
        "BVZUI",
        "VETER"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 150,
            "os": 150,
            "ar": 150,
            "za": 120
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 150,
            "os": 150,
            "ar": 150,
            "za": 120
          }
        }
      ]
    },
    {
      "descriptions": [
        "Zijkanaal G",
        "Zijkanaal G"
      ],
      "berths": [
        "ZGJAN",
        "ZNKKL",
        "ZNSJB",
        "ZNZNE",
        "ZNZSN",
        "ZNZSZ",
        "ZGAA3",
        "ZGAIS",
        "ZGBCO",
        "ZGBCW",
        "ZGDBK",
        "ZGKWB",
        "ZGOH1",
        "ZGOH2",
        "ZGOH3",
        "ZGPK1",
        "ZGPK2",
        "ZGWPS",
        "ZGKEN",
        "ZGPHK",
        "ZGVOO",
        "ZGALG"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {
            "kp": 210,
            "os": 135,
            "ar": 135,
            "za": 15
          }
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {
            "kp": 210,
            "os": 135,
            "ar": 135,
            "za": 15
          }
        }
      ]
    },
    {
      "descriptions": [
        "Zijkanaal H",
        "Zijkanaal H"
      ],
      "berths": [
        "ZHVRE"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    },
    {
      "descriptions": [
        "Zijkanaal K",
        "Zijkanaal K"
      ],
      "berths": [
        "ZKALB"
      ],
      "durations": [
        {
          "criteria": {
            "lengthInCm": "<=12500"
          },
          "minutesFrom": {}
        },
        {
          "criteria": {
            "lengthInCm": ">12500"
          },
          "minutesFrom": {}
        }
      ]
    }
  ]
}